import type { TranslationKeys } from './es';

const pt: TranslationKeys = {
  nav: { services: 'Serviços', about: 'Sobre Nós', blog: 'Blog', zones: 'Zonas', contact: 'Contacto', login: 'Iniciar Sessão', clientArea: 'Área de Cliente', language: 'Idioma', home: 'Início', access: 'Aceder', search: 'Pesquisar em Punto Hispano', searchPlaceholder: 'O que procura? Ex: seguros, alojamento...', noResults: 'Sem resultados para', tryOther: 'Tente outros termos', popularSearches: 'Pesquisas populares:', quickAccess: 'Acesso rápido:', freeConsultation: 'Consulta Gratuita', allZones: 'Todas as Zonas', digitalBusiness: 'Empreenda Digital', aboutUs: 'Sobre Nós', closeMenu: 'Fechar menu', openMenu: 'Abrir menu' },
  hero: { title: 'A sua gestão administrativa na Suíça', subtitle: 'Gestão, assessoria jurídica, seguros, idiomas e soluções digitais para lusófonos na Suíça.', cta: 'Consulta Gratuita', ctaSecondary: 'Ver Serviços', trustBadge: '+2.500 famílias confiam em nós', experience: '+12 anos de experiência', act: 'ATO I', actSubtitle: 'QUEM SOMOS', titleLine1: 'GESTÃO E', titleLine2: 'ASSESSORIA', titleLine3: 'NA SUÍÇA', cinematicSubtitle: 'A sua ponte para o sucesso na Suíça. Mais de 12 anos a ajudar lusófonos.', discoverServices: 'Descobrir Serviços', scheduleConsultation: 'Agendar Consulta' },
  services: { title: 'Os Nossos Serviços', subtitle: 'Tudo para viver tranquilo na Suíça', gestoria: { name: 'Gestão Administrativa', description: 'Gestão completa: RAV, impostos, autorizações, CV, traduções.', cta: 'Ver Serviços' }, legal: { name: 'Assessoria Jurídica', description: 'Direito de estrangeiros, trabalho, família, comercial.', cta: 'Assessoria Jurídica' }, seguros: { name: 'Seguros e Previdência', description: 'Seguros de saúde, vida, habitação, veículos.', cta: 'Orçamento Grátis' }, idiomas: { name: 'Cursos de Idiomas', description: 'Alemão e inglês. Níveis A1 a C1.', cta: 'Ver Cursos' }, digital: { name: 'Soluções Digitais', description: 'Web design, CRM, automação com IA.', cta: 'Ver Portfólio' }, relocation: { name: 'Pacote Relocation', description: 'Tudo para a sua mudança para a Suíça.', cta: 'Pacote Completo' }, vehiculos: { name: 'Aluguer de Veículos', description: 'Aluguer de carros e carrinhas.', cta: 'Ver Veículos' }, viviendas: { name: 'Aluguer de Habitação', description: 'Apartamentos e quartos.', cta: 'Ver Habitações' }, resultsTitle: 'RESULTADOS QUE', resultsTitleAccent: 'TRANSFORMAM', resultsSubtitle: 'Cada serviço resolve um problema real.', viewAll: 'Ver todos os serviços', explore: 'Explorar', gestoriaShort: 'Gestão', gestoriaDesc: 'Impostos, autorizações e trâmites resolvidos sem stress.', gestoriaTags: 'Impostos • Autorizações • RAV', legalShort: 'Assessoria Jurídica', legalDesc: 'Proteja os seus direitos.', legalTags: 'Contratos • Heranças • Vistos', idiomasShort: 'Idiomas', idiomasDesc: 'Quebre a barreira linguística.', idiomasTags: 'Alemão • Inglês • Certificados', segurosShort: 'Seguros', segurosDesc: 'Poupe até 35% nos prémios.', segurosTags: 'Saúde • 3º Pilar • Vida', vehiculosShort: 'Aluguer de Carros', vehiculosDesc: 'Mova-se livremente desde o primeiro dia.', vehiculosTags: 'Carros • Carrinhas • SUV', viviendasShort: 'Aluguer de Habitação', viviendasDesc: 'Encontre a sua casa sem competir.', viviendasTags: 'Quartos • Apartamentos • Partilha', digitalShort: 'Soluções Digitais', digitalDesc: 'Multiplique vendas com site, CRM e IA.', digitalTags: 'Web • CRM • IA', relocationShort: 'Pacote Relocation', relocationDesc: 'Chegue à Suíça sem medo.', relocationTags: 'Tudo incluído', badgeBestSeller: 'Mais vendido', badgeNew: 'Novo', badgeSave: 'Poupe 25%', act: 'ATO II', actSubtitle: 'SERVIÇOS' },
  process: { act: 'ATO III', actSubtitle: 'PROCESSO', title: 'DO SEU PROBLEMA À', titleAccent: 'SUA SOLUÇÃO', subtitle: 'Sem letras miúdas. Assim simples.', step1Title: 'Ouvimo-lo', step1Desc: 'Conte-nos o que o preocupa.', step1Duration: 'Grátis', step2Title: 'Plano Sem Surpresas', step2Desc: 'Saberá exatamente o que fazemos e quanto custa.', step2Duration: '24-48h', step3Title: 'Nós Executamos', step3Desc: 'Continue a sua vida. Nós resolvemos por si.', step3Duration: 'Variável', step4Title: 'Problema Resolvido', step4Desc: 'Ficamos consigo até que tudo esteja 100% resolvido.', step4Duration: 'Contínuo' },
  about: { title: 'Sobre Nós', subtitle: 'Conheça a equipa do Punto Hispano', mission: 'A nossa missão é facilitar a vida na Suíça.', heroTitle: 'Quem somos?', heroSubtitle: 'Somos a ponte entre a sua língua e a burocracia suíça. Desde 2013.', stats: { families: 'Famílias', procedures: 'Processos', companies: 'Empresas', years: 'Anos' }, timeline: { t2013: { title: 'O Primeiro Passo', desc: 'Santiago chega à Suíça.' }, t2019: { title: 'Crescimento Sem Fronteiras', desc: 'Centenas de clientes.' }, t2023: { title: 'A Nossa Casa em Zurique', desc: 'Escritório em Opfikon.' }, t2025: { title: 'Mais de 2.500 Famílias', desc: 'Equipa multidisciplinar.' } }, valuesTitle: 'Os Nossos Valores', values: { transparency: { title: 'Transparência Total', desc: 'Sem letras miúdas.' }, empathy: { title: 'Empatia Real', desc: 'Estivemos no seu lugar.' }, results: { title: 'Resultados, Não Palavras', desc: 'Medimo-nos por problemas resolvidos.' } } },
  contact: { title: 'Contacto', subtitle: 'Tem perguntas? Estamos aqui para ajudar', name: 'Nome', email: 'Email', phone: 'Telefone', message: 'Mensagem', send: 'Enviar Mensagem', whatsapp: 'Escreva-nos no WhatsApp', schedule: 'Agendar Consulta', address: 'Thurgauerstrasse 117, 1° Andar, Escritório 181, 8152 Opfikon, Zurique', heroTitle: 'Como podemos ajudá-lo?', heroSubtitle: 'Estamos a uma mensagem de distância. Primeira consulta gratuita.', officeTitle: 'O Nosso Escritório', hours: 'Horário: Seg-Sex 09:00-18:00', responseTime: 'Respondemos em menos de 2 horas', freeConsultation: 'Primeira consulta 100% gratuita' },
  zones: { title: 'Zonas de Serviço', subtitle: 'De Zurique, para o mundo inteiro', description: 'Gestão, assessoria jurídica, seguros e mais.', headquarters: 'Sede Principal', cities: 'cidades', countriesTitle: 'Países com Maior Presença', notFound: 'Não encontra a sua zona?', notFoundDesc: 'Podemos ajudá-lo online.', servicesIn: 'Serviços em', heroTitle: 'Onde Estiver, Ajudamo-lo', heroSubtitle: 'Serviços profissionais de Zurique para toda a Europa.', europeTitle: 'Europa', allCountries: 'Ver todos os países', remoteServices: 'Serviços 100% online disponíveis' },
  blog: { title: 'Blog', subtitle: 'Dicas, guias e notícias', readMore: 'Ler mais', readTime: 'min de leitura', categories: 'Categorias', search: 'Pesquisar artigos...' },
  footer: { description: 'A sua gestão administrativa na Suíça', rights: 'Todos os direitos reservados', privacy: 'Política de Privacidade', cookies: 'Política de Cookies', legal: 'Aviso Legal', gdpr: 'RGPD', brandDesc: 'O seu parceiro integral na Suíça.', newsletter: 'Newsletter', newsletterDesc: 'Receba novidades e ofertas exclusivas', subscribe: 'Subscrever', emailPlaceholder: 'nome@exemplo.com', followUs: 'Siga-nos em', servicesTitle: 'Serviços', gestoriaTitle: 'Gestão', lifestyleTitle: 'Lifestyle', zonesTitle: 'Zonas', companyTitle: 'Empresa', legalTitle: 'Legal', zonesLink: 'Zonas de Serviço', madeWith: 'Desenvolvido com ❤️ por', desempleo: 'Desemprego (RAV)', administracion: 'Administração', cvDoc: 'CV e Documentos', acompanamientos: 'Acompanhamentos', traducciones: 'Traduções', paquetes: 'Pacotes Especiais' },
  common: { learnMore: 'Saber Mais', viewAll: 'Ver Todos', back: 'Voltar', next: 'Seguinte', previous: 'Anterior', close: 'Fechar', loading: 'A carregar...', error: 'Ocorreu um erro', retry: 'Tentar novamente', search: 'Pesquisar', noResults: 'Sem resultados', freeConsultation: 'Consulta Gratuita', whatsapp: 'WhatsApp', schedule: 'Agendar', callUs: 'Ligue-nos', from: 'Desde', our: 'Nossos', all: 'Todos' },
  audience: { trustLine: 'Mais de 12 anos a ajudar lusófonos na Suíça', empathy: 'Isto soa-lhe familiar?', empathyItems: ['Não entende as cartas oficiais', 'Sente-se perdido com a burocracia', 'Precisa de ajuda com os impostos', 'Procura alguém que fale a sua língua'], processTitle: 'Assim Simples', processSteps: [{ title: 'Conte-nos o seu caso', description: 'Por WhatsApp ou consulta' }, { title: 'Aconselhamo-lo', description: 'Análise e opções' }, { title: 'Resolvemos', description: 'Gestão profissional por si' }] },
  navStructure: { traditional: 'Tradicionais', lifestyle: 'Lifestyle', digital: 'Digitais', europe: 'Europa', america: 'América', other: 'Outros', viewAllZones: 'Ver todas as zonas', desempleo: 'Desemprego e RAV', administracion: 'Administração', cvDoc: 'CV e Documentos', traducciones: 'Traduções', paquetes: 'Pacotes Especiais', extranjeria: 'Estrangeiros e Autorizações', laboral: 'Direito do Trabalho', familia: 'Direito da Família', mercantil: 'Direito Comercial', inmobiliario: 'Imobiliário e Fiscal', aleman: 'Alemão', ingles: 'Inglês', seguroSalud: 'Seguro de Saúde', vidaPension: 'Vida e Previdência', hogarVehiculos: 'Habitação e Veículos', siniestros: 'Sinistros', comparador: 'Comparador', packBasico: 'Pacote Básico', packCompleto: 'Pacote Completo', paraEmpresas: 'Para Empresas', packRetorno: 'Pacote Retorno', formacionIdiomas: 'Cursos de Idiomas', segurosYPensiones: 'Seguros e Previdência', alquilerVehiculos: 'Aluguer de Veículos', alquilerViviendas: 'Aluguer de Habitação', solucionesDigitales: 'Soluções Digitais' },
  testimonials: { act: 'ATO IV', actSubtitle: 'TESTEMUNHOS', title: 'ELES JÁ VIVEM', titleAccent: 'SEM PREOCUPAÇÕES', subtitle: 'Histórias reais de pessoas como si', reviews: 'avaliações', viewReal: 'Ver avaliações reais no Google Maps', disclaimer: 'As avaliações mostradas abaixo são representativas da experiência dos nossos clientes. Para ver as nossas avaliações autênticas e verificadas, visite o nosso perfil no Google Maps.' },
  faq: { act: 'ATO V', actSubtitle: 'FAQ', title: 'PERGUNTAS', titleAccent: 'FREQUENTES', subtitle: 'Tudo o que precisa saber.', ctaText: 'Tem outra dúvida?', ctaLink: 'Contacte-nos diretamente', showMore: 'Ver mais perguntas', showLess: 'Ver menos' },
  cta: { act: 'ATO VI', actSubtitle: 'CONTACTO', urgencyBadge: 'Vagas limitadas — Apenas 5 consultas gratuitas esta semana', title: 'NÃO ESPERE ATÉ QUE', titleAccent: 'SEJA TARDE', subtitle: 'Cada dia sem resolver é stress desnecessário. Dê o primeiro passo — é grátis.', step1Label: 'Selecione serviço', step2Label: 'Dados', step3Label: 'Confirmação', stepTitle: 'Que serviço lhe interessa?', continueBtn: 'Continuar para o passo 2', trustResponse: 'Respondemos em menos de 24h', trustFamilies: '+2500 famílias já resolveram', trustLanguage: '100% na sua língua', serviceOther: 'Outro / Não tenho a certeza' },
  trust: { headline: '+2.500 pessoas libertaram-se da burocracia suíça', verifiedLabel: 'Empresas verificadas:', dataProtected: 'Dados 100% protegidos', dataProtectedSub: 'A sua informação é sagrada', registered: 'Empresa registada na Suíça', registeredSub: 'Verificável no Moneyhouse', realOffice: 'Escritório real em Zurique', realOfficeSub: 'Não somos uma caixa postal', experience: '12+ anos, 2500+ famílias', experienceSub: 'Resultados comprováveis' },
  homeFaq: { questions: [{ question: 'Acabei de chegar à Suíça e não sei por onde começar. Podem ajudar-me?', answer: 'Absolutamente. Sabemos como é avassalador chegar a um novo país. O nosso Pack Relocation cobre tudo: autorizações, seguros, banco, habitação e mais. Um coordenador pessoal guia-te passo a passo.' }, { question: 'Quanto custa a primeira consulta? Há compromisso?', answer: 'A primeira consulta é 100% gratuita e sem compromisso. Em 10 minutos ouvimos o teu caso, entendemos o que precisas e explicamos como podemos ajudar.' }, { question: 'Estou a pagar demais em impostos. Podem otimizar a minha declaração?', answer: 'É o que fazemos melhor. Em mais de 12 anos recuperámos milhares de francos para os nossos clientes com deduções que desconheciam.' }, { question: 'Tenho um problema legal e não entendo as leis suíças. O que faço?', answer: 'Não estás sozinho. Os nossos consultores legais falam a tua língua e conhecem o direito suíço em detalhe. Contratos de trabalho, reagrupamento familiar, heranças, autorizações — protegemos os teus direitos.' }, { question: 'Preciso de aprender alemão mas os cursos convencionais não funcionam para mim.', answer: 'Porque não são desenhados para falantes de espanhol. A nossa metodologia parte das dificuldades específicas. Cursos de A1 a C1, presenciais em Zurique ou online.' }, { question: 'Como sei se estou a pagar demais pelo meu seguro de saúde?', answer: 'Provavelmente sim — 70% dos nossos clientes poupam em média 35% após a nossa comparação gratuita.' }, { question: 'Atendem apenas em Zurique ou também à distância?', answer: 'O nosso escritório é em Opfikon (Zurique), mas atendemos clientes de toda a Suíça e do estrangeiro. 80% dos nossos serviços são 100% online.' }, { question: 'Porque devo confiar na Punto Hispano e não noutro prestador?', answer: 'Porque somos uma empresa registada e verificável no Moneyhouse. Mais de 2.500 famílias escolheram-nos. 4,9 estrelas no Google.' }], additionalQuestions: [{ question: 'Onde ficam exatamente? Posso ir ao escritório?', answer: 'Sim, estamos na Thurgauerstrasse 117, 8152 Opfikon, Zurique (1° Andar, Escritório 181). Segunda a sexta 9:00-18:00, sábados com marcação.' }, { question: 'Quero assegurar a minha reforma. Que opções tenho com o 3° Pilar?', answer: 'O 3° Pilar é a melhor ferramenta para assegurar o teu futuro E poupar nos impostos hoje. Comparamos todas as opções de mercado.' }, { question: 'O meu negócio precisa de presença digital. Podem ajudar?', answer: 'Desenhamos sites que vendem. CRM personalizado, automação IA, marketing digital e SEO.' }, { question: 'Preciso de um carro sem complicações de contratos longos.', answer: 'Aluguer flexível: de dias a meses. Utilitários, SUVs e carrinhas. Seguro contra todos os riscos incluído.' }, { question: 'Encontrar apartamento na Suíça é impossível. Podem realmente ajudar-me?', answer: 'Temos acesso a uma rede exclusiva de proprietários, gerimos visitas e acompanhamos-te até à assinatura.' }, { question: 'O que inclui exatamente o Pack Relocation?', answer: 'TUDO: procura de habitação, abertura de conta bancária, registo municipal, seguros obrigatórios, CV adaptado, cursos de alemão e um coordenador pessoal. Poupa 25%.' }, { question: 'Como pago? Aceitam pagamentos parcelados?', answer: 'Transferência, cartão, TWINT ou PayPal. Sim, oferecemos parcelamento para serviços de maior valor.' }, { question: 'Ainda não tenho autorização de residência. Podem ajudar-me na mesma?', answer: 'Sim. Ajudamos a regularizar situações migratórias e aconselhamos sobre as melhores vias para obter a tua autorização.' }] },
  seo: { homeTitle: 'Punto Hispano | Gestão Administrativa na Suíça', homeDescription: 'Melhor gestão e assessoria em Zurique para lusófonos na Suíça.' },
  servicesIndex: { heroTitle: 'Todos os Nossos Serviços', heroSubtitle: 'A sua solução integral na Suíça.', heroCta: 'Consulta Gratuita por WhatsApp', categories: { gestoria: { title: 'Gestão Administrativa', description: 'Impostos, RAV, autorizações — nós tratamos de tudo.', cta: 'Quero parar de me preocupar', features: ['Declaração sem erros', 'Autorizações em dia', 'Sem stress', 'Poupança fiscal real'] }, legal: { title: 'Assessoria Jurídica', description: 'Um contrato que não entende pode custar milhares de francos.', cta: 'Proteger os meus direitos', features: ['Contratos revistos', 'Autorizações resolvidas', 'Reagrupamento familiar', 'Tranquilidade legal'] }, idiomas: { title: 'Cursos de Idiomas', description: 'Sem língua, não há trabalho. Os nossos cursos são para falar.', cta: 'Começar a falar', features: ['Professores nativos', 'Níveis A1-C1', 'Grupos reduzidos', 'Certificados oficiais'] }, seguros: { title: 'Seguros e Previdência', description: 'Todos os anos perde centenas de francos por não comparar.', cta: 'Comparar e poupar', features: ['Até 35% poupança', 'Consultor pessoal', 'Todas as seguradoras', 'Sem compromisso'] }, digital: { title: 'Soluções Digitais', description: 'A sua concorrência já tem site e CRM. E si?', cta: 'Ver o que podemos fazer', features: ['Site profissional', 'CRM personalizado', 'IA e automação', 'Marketing digital'] }, vehiculos: { title: 'Aluguer de Veículos', description: 'Mova-se livremente. Carros, carrinhas e SUV.', cta: 'Ver veículos', features: ['Sem caução excessiva', 'Seguro incluído', 'Recolha flexível', 'Preços competitivos'] }, viviendas: { title: 'Aluguer de Habitação', description: 'Encontre a sua casa sem competir com 200 candidatos.', cta: 'Procurar habitação', features: ['Verificados', 'Sem comissão oculta', 'Curta e longa duração', 'Zonas centrais'] }, relocation: { title: 'Pacote Relocation', description: 'Chegue à Suíça com tudo resolvido.', cta: 'Quero chegar tranquilo', features: ['Tudo incluído', 'Consultor pessoal', 'Antes de chegar', 'Garantia de resultado'] } } },
  aboutPage: { seoTitle: 'Sobre o Punto Hispano — Gestão Administrativa na Suíça', seoDesc: 'Conheça o Punto Hispano: 12+ anos ajudando na Suíça.', heroSub: 'Sobre o Punto Hispano — Gestão Administrativa na Suíça', heroTitle1: 'A Gestoria de Confiança', heroTitle2: 'para ', heroTitle3: 'Lusófonos', heroTitle4: 'na Suíça', heroDesc: 'Chegámos à Suíça como tu. Sabemos o que é não entender uma carta das finanças. Por isso criámos o Punto Hispano.', knowServices: 'Conhece os Nossos Serviços →', talkToUs: 'Fala Connosco', originTitle: 'Não Criámos uma Empresa. Resolvemos um Problema Que Vivemos.', originP1: 'Em 2013, Santiago Castillo enfrentou o mesmo: um país novo, um idioma que não dominava. Procurou ajuda em espanhol e não encontrou. Então criou-a.', originP2: 'Hoje, o Punto Hispano é onde mais de 2.500 famílias encontraram alguém que fala a sua língua e defende os seus direitos.', originP3: 'Não somos uma empresa que vende serviços. Somos pessoas que resolveram o mesmo problema.', originBadge: '🇨🇭 Desde Zurique, para toda a comunidade na Suíça', timelineTitle: '12 Anos a Crescer Contigo', founderTag: 'Fundador', founderName: 'Santiago Castillo', founderQuote: '"Cheguei à Suíça com uma mala e zero contactos. Ninguém me explicou os impostos, seguros ou autorizações. A ajuda em espanhol não existia. Então criei-a."', founderDesc: 'Hoje, mais de 12 anos depois, o Punto Hispano é a referência da comunidade.', founderExp: 'Mais de 12 anos de experiência', teamTitle: 'Uma Equipa Completa ao Teu Serviço', teamSubtitle: 'Tudo sob o mesmo teto.', teamStats: [{ number: '8+', text: 'Profissionais', sub: 'Gestores, advogados, consultores de seguros, professores de idiomas' }, { number: '100%', text: 'Equipa que fala a tua língua', sub: 'Entendemo-nos sem tradutores.' }, { number: '5+', text: 'Áreas de especialização', sub: 'Gestão, jurídico, seguros, idiomas, digital' }], missionTitle: 'A Nossa Missão', missionWhat: 'O Que Fazemos Todos os Dias', missionWhatDesc: 'Resolver os problemas reais. Sem serviços genéricos: ouvimos, compreendemos e resolvemos profissionalmente.', missionWhere: 'Para Onde Vamos', missionWhereDesc: 'Que ninguém se sinta sozinho perante um problema. Queremos ser a tua primeira chamada.', allServices: 'Tudo o Que o Punto Hispano Pode Fazer por Ti', allServicesSub: 'Mais de 20 soluções específicas.', commitmentsTitle: 'Três Compromissos que Cumprimos Sempre', commitments: [{ title: 'Resposta em Menos de 2 Horas', desc: 'Em horário laboral, respondemos em 2 horas no máximo.', proof: 'Compromisso verificável' }, { title: 'Primeira Consulta Grátis', desc: 'Ouvimos e damos um diagnóstico claro. Sem compromisso.', proof: '100% gratuita' }, { title: '4.9★ no Google', desc: 'Mais de 2.500 famílias nos escolheram e nos recomendam.', proof: 'Avaliações reais' }], joinTitle: 'Queres Fazer Parte da Equipa?', joinDesc: 'Procuramos profissionais apaixonados.', joinCta: '✉️ Envia-nos o teu CV →', finalTitle: 'Tens um Problema na Suíça? Conta-nos.', finalDesc: 'Não tens de resolver tudo sozinho/a. Dá o primeiro passo.', finalCta: 'Agendar Consulta Grátis →', finalServices: 'Ver Todos os Serviços →' },
  zonesPage: { seoTitle: 'Zonas de Serviço | Punto Hispano - De Zurique para Todo o Mundo', seoDesc: 'Gestão administrativa, assessoria jurídica, seguros e mais.', heroTitle: 'Atendemos a Tua Zona', heroSubtitle: 'Desde Zurique, para todo o mundo. Gestão, assessoria jurídica, seguros e mais.', hq: 'Sede Principal', switzerland: 'Suíça', switzerlandDesc: 'Com escritório em Opfikon (Zurique), atendemos toda a comunidade na Suíça.', countriesTitle: 'Países com Maior Presença', countriesSubtitle: 'Encontra os nossos serviços na Suíça, Espanha, Itália e América Latina.', cities: 'cidades', notFoundTitle: 'Não encontras a tua zona?', notFoundDesc: 'Onde estiveres, podemos ajudar-te online.', whatsappCta: 'Contactar por WhatsApp', scheduleCta: 'Agendar Consulta' },
  blogPage: { seoTitle: 'Blog Punto Hispano | Guias para a Vida na Suíça', seoDesc: 'Guias sobre impostos, autorizações, seguros e vida na Suíça.', heroTitle: 'Blog do Punto Hispano — ', heroTitleAccent: 'Guias e Dicas para a Vida na Suíça', heroDesc: 'Tudo o que precisas saber para viver, trabalhar e prosperar na Suíça.', all: 'Todos', readArticle: 'Ler artigo', readTime: 'min de leitura', noArticles: 'Nenhum artigo disponível nesta categoria.', newsletterTitle: '📬 Recebe os Nossos Artigos no Teu Email', newsletterDesc: 'Um email por semana. Sem spam, só conteúdo útil.', emailPlaceholder: 'O teu email...', subscribe: 'Subscrever', noSpam: '🔒 Sem spam. Cancelar quando quiseres.' },
  blogPost: { home: 'Início', blog: 'Blog', author: 'Equipa Punto Hispano', minRead: 'min de leitura', needHelpMobileTitle: 'Precisas de ajuda com isto?', needHelpMobileDesc: 'Primeira consulta gratuita. A nossa equipa pode tratar disto por ti.', scheduleConsult: 'Marcar Consulta →', endCtaTitle: 'Queres que tratemos disto por ti?', endCtaDesc: 'Não tens de o fazer sozinho/a. Marca a tua consulta gratuita e explicamos-te exatamente como te podemos ajudar.', endCtaButton: 'Marcar Consulta Gratuita →', endCtaResponse: '⏰ Resposta em menos de 2 horas em horário laboral', keepReading: 'Continuar a ler', backToBlog: 'Voltar ao Blog', sidebarHelpTitle: 'Precisas de ajuda?', sidebarHelpDesc: 'Primeira consulta gratuita. A nossa equipa pode tratar disto por ti.', relatedArticles: 'Artigos relacionados', mobileStickyCta: 'Consulta gratuita' },
  zonesDetail: {
    seoTitleCountry: 'Serviços em {country} | Punto Hispano - Atendimento desde Zurique',
    seoDescCountry: 'Gestão, assessoria jurídica, seguros e idiomas em {country}. Atendimento presencial e online desde Opfikon, Zurique.',
    seoTitleCity: 'Serviços em {city}, {country} | Punto Hispano',
    seoDescCity: 'Gestão, assessoria jurídica, seguros e mais em {city}. Atendimento presencial e online desde Opfikon, Zurique.',
    citiesIn: 'Cidades em {country}',
    findYourCity: 'Encontra a tua cidade e descobre todos os serviços disponíveis.',
    cities: 'cidades',
    featured: '★ Destaque',
    noZones: 'Não há zonas disponíveis neste país atualmente.',
    contactAnyway: 'Contactar mesmo assim',
    dontSeeCity: 'Não vês a tua cidade?',
    dontSeeCityDesc: 'Não importa onde estejas em {country}, atendemos-te online desde Zurique.',
    contactWhatsApp: 'Contactar por WhatsApp',
    allZones: 'Todas as zonas',
    servicesForIn: 'Serviços para Lusófonos em {city}',
    servicesFullDesc: 'No Punto Hispano, oferecemos uma gama completa de serviços em {city}. Desde gestão administrativa a assessoria jurídica, seguros, cursos de idiomas e soluções digitais. O nosso escritório principal está em Opfikon (Zurique), mas atendemos-te online onde estiveres.',
    needHelpIn: 'Precisas de ajuda em {city}?',
    remoteAttention: 'Mesmo estando em {city}, atendemos-te como se estivesses no nosso escritório de Zurique. Contacta-nos hoje.',
    officeOpfikon: 'Escritório em Opfikon, Suíça',
    inPersonAndOnline: 'Atendimento presencial e online',
    scheduleConsultation: 'Agendar Consulta',
    otherCitiesIn: 'Outras cidades em {country}',
    exploreMore: 'Explora mais zonas onde oferecemos os nossos serviços.',
    viewAllCitiesIn: 'Ver todas as cidades em {country}',
    backTo: 'Voltar a {country}',
    allServices: 'Todos os Nossos Serviços',
    servicesIn: 'Serviços em {zone}',
    availableFromOffice: 'Disponíveis presencialmente e online desde o nosso escritório em Opfikon, Zurique.',
    viewMore: 'Saber mais',
    mainOffice: 'Escritório Principal',
    onlineConsultation: 'Consulta Online',
    serviceGestoria: 'Gestão',
    serviceGestoriaDesc: 'Impostos, autorizações, RAV',
    serviceLegal: 'Assessoria Jurídica',
    serviceLegalDesc: 'Contratos, vistos, heranças',
    serviceLanguages: 'Idiomas',
    serviceLanguagesDesc: 'Alemão, inglês, certificados',
    serviceInsurance: 'Seguros',
    serviceInsuranceDesc: 'Saúde, vida, 3º pilar',
    serviceCarRental: 'Aluguer de Carros',
    serviceCarRentalDesc: 'Carros, carrinhas',
    serviceHousing: 'Habitação',
    serviceHousingDesc: 'Quartos, apartamentos, partilha',
    serviceDigital: 'Digital',
    serviceDigitalDesc: 'Web, CRM, IA, automação',
    serviceRelocation: 'Pacote Relocation',
    serviceRelocationDesc: 'Tudo incluído para começar',
    howWeHelp: 'Como Te Ajudamos',
    remotely: 'à Distância',
    remoteDesc: 'Mesmo estando em {city}, atendemos-te como no nosso escritório de Zurique.',
    remoteDescGeneral: 'Desde Zurique, para todo o mundo. Atendimento profissional independentemente da tua localização.',
    step1Title: 'Contacta-nos',
    step1Desc: 'Escreve-nos por WhatsApp, email ou liga. Resposta em menos de 24h.',
    step2Title: 'Consulta Online',
    step2Desc: 'Agendamos uma videochamada para entender a tua situação e necessidades.',
    step3Title: 'Resolução',
    step3Desc: 'Gerimos tudo remotamente. Tu só assinas os documentos necessários.',
    benefit1: 'Resposta em 24h',
    benefit2: '+12 anos de experiência',
    benefit3: 'Atendimento multilingue',
    home: 'Início',
    zones: 'Zonas',
    gestoriaAndAdvice: 'Gestão e Assessoria em {city}',
    professionalServices: 'Serviços profissionais em {city}',
    servicesDescription: 'Gestão, assessoria jurídica, seguros e mais em {country}. Atendimento desde o nosso escritório em Zurique.',
  },
  gestoriaPage: {
    seoTitle: 'Gestão Administrativa na Suíça | Impostos, Autorizações, ORP | Punto Hispano',
    seoDesc: 'Gestão administrativa em espanhol na Suíça. Inscrição ORP, declaração de impostos, traduções oficiais, criação de empresas. Mais de 12 anos de experiência.',
    heroTitle: 'Gestão Administrativa na Suíça',
    heroAccent: '— Impostos, Autorizações e ORP em Espanhol',
    heroDesc: 'Mais um ano sem entender a sua declaração de impostos? Cartas do ORP que não sabe responder? Nós tratamos de tudo. Você só recebe o resultado.',
    heroCta: 'Ver todos os serviços ↓',
    heroWhatsapp: 'Consulta gratuita por WhatsApp',
    badge1: '+2.500 famílias',
    badge2: 'Resposta < 2h',
    badge3: '12+ anos',
    empathyTitle: 'Isso lhe parece familiar?',
    empathy1: 'O prazo da declaração chega e você não entende nem a primeira linha',
    empathy2: 'Recebe cartas do ORP em alemão e não sabe o que estão pedindo',
    empathy3: 'Precisa renovar a autorização e tem medo de que seja recusada',
    empathy4: 'Quer abrir uma empresa mas a burocracia suíça o paralisa',
    empathyBottom: 'Se se identifica, está no lugar certo.',
    categoriesTitle: 'O que precisa resolver?',
    categoriesDesc: 'Escolha a sua situação e mostramos exatamente como podemos ajudar.',
    packagesTitle: 'Pacotes tudo-em-um',
    packagesDesc: 'Soluções completas para situações concretas.',
    requestPack: 'Solicitar pacote',
    processTitle: 'Assim de fácil',
    step1Title: 'Conte-nos o seu caso',
    step1Desc: 'Escreva-nos por WhatsApp ou preencha o formulário',
    step2Title: 'Receba o seu plano',
    step2Desc: 'Dizemos o que precisa e quanto custa',
    step3Title: 'Nós tratamos de tudo',
    step3Desc: 'Você nos dá os documentos, nós fazemos o resto',
    ctaTitle: 'Não sabe qual serviço precisa?',
    ctaDesc: 'Conte-nos a sua situação e dizemos exatamente o que precisa. Grátis e sem compromisso.',
    ctaWhatsapp: 'Consulta grátis por WhatsApp',
    ctaSchedule: 'Agendar chamada',
    faqTitle: 'Perguntas frequentes',
    faq1Q: 'Quanto custa a inscrição no ORP?',
    faq1A: 'Escreva-nos por WhatsApp ou preencha o nosso formulário de contacto e enviamos um orçamento personalizado em menos de 2 horas. O Pack Inscrição ORP inclui toda a documentação, CV formato suíço, carta de apresentação, registo no JOB-room e acompanhamento à primeira consulta.\n\n⚠️ Lembre-se: deve inscrever-se ANTES do primeiro dia sem trabalho.',
    faq2Q: 'Como posso fazer a minha declaração de impostos?',
    faq2A: 'Pode fazê-la sozinho ou contratar o nosso serviço de declaração de impostos. Revemos a sua situação completa, aplicamos TODAS as deduções possíveis e apresentamos dentro do prazo.\n\n⚠️ Prazo: na maioria dos cantões, a data limite é 31 de março.',
    faq3Q: 'A primeira consulta é gratuita?',
    faq3A: 'Sim. Oferecemos uma primeira consulta gratuita de 10 minutos onde ouvimos o seu caso e identificamos o que precisa. Pode vir ao nosso escritório em Opfikon, ligar-nos ou escrever por WhatsApp. Sem compromisso.',
    faqMore: 'Mais perguntas? Contacte-nos →',
    reviewsTitle: 'O que dizem os nossos clientes',
    reviewsDesc: 'Experiências reais de famílias hispanófonas',
    reviewsMore: 'Ver todas as avaliações no Google →',
    crossSellTitle: 'Descubra os nossos outros serviços',
    crossSellDesc: 'Tudo o que um hispanófono precisa na Suíça, sob o mesmo teto.',
    finalTitle: 'Pare de se preocupar. Comece hoje.',
    finalDesc: 'Cada dia sem resolver as suas burocracias é mais um dia de stress.',
    finalCta: 'Consulta gratuita por WhatsApp',
    finalBack: 'Ver serviços ↑',
  },
  homeSeo: {
    title: 'Punto Hispano | Gestão, Jurídico e Relocation na Suíça',
    description: 'Perdido com a burocracia na Suíça? +2500 hispanófonos recuperaram a tranquilidade. Impostos, autorizações, seguros, habitação e mais.',
    skipButton: 'Ver site completo',
  },

  legalPage: {
    seoTitle: 'Assessoria Jurídica para Hispanófonos na Suíça | Punto Hispano',
    seoDesc: 'Assessoria jurídica em espanhol na Suíça. Imigração, trabalho, família, comercial, imobiliário. Primeira consulta gratuita.',
    heroTitle: 'Assessoria Jurídica para Hispanófonos na Suíça',
    heroAccent: '— Autorizações, Trabalho, Família e Empresas em Espanhol',
    heroDesc: 'Problemas com a sua autorização, despedimento injusto, divórcio, dívidas... Não precisa resolver sozinho/a. Aconselhamos em espanhol com especialistas em direito suíço.',
    heroCta: 'Ver Áreas de Prática ↓',
    heroWhatsapp: 'Consulta Gratuita por WhatsApp',
    badge1: '+2.500 famílias',
    badge2: 'Resposta < 2h',
    badge3: '12+ anos',
    empathyTitle: 'Alguma destas situações parece-lhe familiar?',
    empathy1: 'Foi despedido/a e acha injusto mas não sabe o que fazer',
    empathy2: 'Está em processo de divórcio e não entende a lei suíça',
    empathy3: 'Negaram-lhe a autorização e não sabe como recorrer',
    empathy4: 'O senhorio aumentou a renda e não sabe se é legal',
    empathyBottom: 'Se se identifica com alguma, está no sítio certo.',
    categoriesTitle: 'As Nossas Áreas de Prática Jurídica',
    categoriesDesc: 'Escolha a sua situação e mostramos como podemos ajudar.',
    cat1Name: 'Imigração e Autorizações',
    cat1Desc: 'Autorizações B, C, G, renovações, reagrupamento familiar, recurso por recusa, cidadania suíça.',
    cat1Badge: '7 serviços disponíveis',
    cat2Name: 'Direito do Trabalho',
    cat2Desc: 'Despedimentos, contratos, reclamações, mobbing, certificados de trabalho, horas extra, falência.',
    cat2Badge: '8 serviços disponíveis',
    cat3Name: 'Direito da Família',
    cat3Desc: 'Divórcios, custódia, pensões alimentícias, separação de bens, mediação, reagrupamento de filhos.',
    cat3Badge: '7 serviços disponíveis',
    cat4Name: 'Direito Comercial e Empresarial',
    cat4Desc: 'Constituição de empresas, contratos, disputas entre sócios, cobrança de dívidas, reclamações de seguros.',
    cat4Badge: '6 serviços disponíveis',
    cat5Name: 'Imobiliário e Fiscal',
    cat5Desc: 'Compra/venda, arrendamentos, disputas com senhorios, otimização fiscal, recursos tributários.',
    cat5Badge: '6 serviços disponíveis',
    viewServices: 'Ver serviços →',
    ctaTitle: 'Não sabe que área jurídica precisa?',
    ctaDesc: 'Conte-nos a sua situação e orientamos gratuitamente. Sem compromisso.',
    ctaWhatsapp: 'Consulta Gratuita por WhatsApp',
    ctaSchedule: 'Agendar Chamada',
    processTitle: 'Assim de fácil',
    step1: 'Conte-nos o seu caso',
    step2: 'Receba o seu plano jurídico',
    step3: 'Nós tratamos de tudo',
    faqTitle: 'Perguntas Frequentes',
    faqMore: 'Ver mais perguntas →',
    reviewsTitle: 'O que dizem os nossos clientes',
    crossSellTitle: 'Descubra os nossos outros serviços',
    crossSellDesc: 'Tudo o que um hispanófono precisa na Suíça, sob o mesmo teto.',
    finalTitle: 'Precisa de assessoria jurídica?',
    finalDesc: 'Primeira consulta gratuita com os nossos especialistas em direito suíço.',
    finalCta: 'Solicitar Consulta Gratuita',
  },

  idiomasPage: {
    seoTitle: 'Formação em Idiomas para Hispanófonos na Suíça | Punto Hispano',
    seoDesc: 'Cursos de alemão e inglês desenhados para hispanófonos. Aulas presenciais e online em Zurique.',
    heroTitle: 'Formação em Idiomas para Hispanófonos na Suíça',
    heroAccent: '— Alemão, Inglês e Certificações Oficiais',
    heroDesc: 'Das melhores escolas de Zurique com metodologia desenhada para hispanófonos. Aprenda mais rápido, com menos frustração, e certifique-se com garantia.',
    heroCta: 'Ver Cursos ↓',
    badge1: '+450 estudantes',
    empathyTitle: 'Alguma destas situações parece-lhe familiar?',
    empathy1: 'Não entende nada no escritório e tudo é em alemão',
    empathy2: 'Precisa do B1 para a autorização C e não sabe por onde começar',
    empathy3: 'O seu chefe pede inglês profissional e bloqueia nas reuniões',
    empathy4: 'Quer certificar-se mas os exames oficiais assustam-no',
    empathyBottom: 'Se se identifica com alguma, está no sítio certo.',
    coursesTitle: 'O que quer aprender?',
    coursesDesc: 'Escolha o seu objetivo e mostramos o caminho mais rápido.',
    germanTitle: 'Cursos de Alemão',
    germanDesc: 'Presencial e online. Aulas em grupo e privadas. De A1 a C1, com metodologia adaptada para hispanófonos.',
    germanBadge: 'Presencial · Online · Privado',
    germanCta: 'Ver cursos de alemão →',
    englishTitle: 'Cursos de Inglês',
    englishDesc: 'Presencial e online. Aulas em grupo e privadas. Business English, conversação e preparação de certificações.',
    englishBadge: 'Presencial · Online · Privado',
    englishCta: 'Ver cursos de inglês →',
    processTitle: 'Assim de fácil',
    step1Title: 'Faça o seu teste de nível',
    step1Desc: 'Avaliamos o seu nível atual numa chamada ou com o nosso formulário',
    step2Title: 'Escolha o seu curso',
    step2Desc: 'Recomendamos o programa ideal para os seus objetivos',
    step3Title: 'Comece a falar',
    step3Desc: 'Desde a primeira aula pratica conversação real',
    ctaTitle: 'Não sabe que curso precisa?',
    ctaDesc: 'Faça o teste de nível gratuito e recomendamos o programa perfeito.',
    ctaWhatsapp: 'Contacte-nos por WhatsApp',
    faqTitle: 'Perguntas Frequentes',
    faqMore: 'Mais perguntas? Escreva-nos →',
    reviewsTitle: 'O que dizem os nossos estudantes',
    reviewsDesc: 'Experiências reais de hispanófonos que aprenderam connosco',
    reviewsMore: 'Ver todas as avaliações no Google →',
    crossSellTitle: 'Descubra os nossos outros serviços',
    crossSellDesc: 'Tudo o que um hispanófono precisa na Suíça, sob o mesmo teto.',
    finalTitle: 'Pronto/a para dominar o idioma?',
    finalDesc: 'Cada semana sem aprender é uma oportunidade perdida.',
    finalCta: 'Aula de prova gratuita',
  },

  segurosPage: {
    seoTitle: 'Seguro de Saúde em Espanhol na Suíça | LAMal | Terceiro Pilar | Punto Hispano',
    seoDesc: 'Consultoria de seguros em espanhol na Suíça. Seguro de saúde obrigatório LAMal, terceiro pilar, pensões. Consultoria gratuita. Poupe até 30%.',
    heroTitle: 'Seguros e Pensões para Hispanófonos na Suíça',
    heroAccent: '— LAMal, Terceiro Pilar e Poupança em Espanhol',
    heroDesc: '70% dos hispanófonos na Suíça paga mais do que o necessário pelo seguro de saúde. Analisamos a sua apólice, encontramos a poupança e gerimos a mudança completa.',
    heroCta: 'Ver todos os serviços ↓',
    heroWhatsapp: 'Consulta gratuita por WhatsApp',
    breadServices: 'Serviços',
    breadSeguros: 'Seguros e Pensões',
    badge1: 'CICERO N.° 31700',
    badge2: 'FINMA N.° F014686595',
    badge3: '+20.000 pessoas seguradas em 5 anos',
    empathyTitle: 'Alguma destas situações parece-lhe familiar?',
    empathy1: 'Há anos que não revê o terceiro pilar e não sabe se está a perder dinheiro',
    empathy2: 'A sua família cresceu mas o seguro ficou igual',
    empathy3: 'Recebe cartas da seguradora em alemão e não entende o que pedem',
    empathy4: 'Paga mais de 400 CHF/mês de seguro de saúde e não sabe se é necessário',
    empathyBottom: 'Se se identifica com alguma, está no sítio certo.',
    servicesTitle: 'O que precisa proteger?',
    servicesDesc: 'Escolha a sua situação e mostramos como poupar sem perder cobertura.',
    processTitle: 'Assim de fácil',
    step1Title: 'Conte-nos a sua situação',
    step1Desc: 'Diga-nos que seguros tem e quanto paga',
    step2Title: 'Comparamos por si',
    step2Desc: 'Analisamos todas as opções do mercado suíço',
    step3Title: 'Poupa sem esforço',
    step3Desc: 'Gerimos a mudança completa. Só precisa assinar',
    ctaTitle: 'Está a pagar demais pelo seu seguro?',
    ctaDesc: 'Envie-nos a sua apólice atual e em 24h dizemos quanto pode poupar. Grátis e sem compromisso.',
    ctaWhatsapp: 'Consulta gratuita por WhatsApp',
    ctaSchedule: 'Agendar chamada',
    faqTitle: 'Perguntas Frequentes',
    faqMore: 'Mais perguntas? Escreva-nos →',
    reviewsTitle: 'O que dizem os nossos clientes',
    reviewsDesc: 'Experiências reais de famílias que pouparam connosco',
    reviewsMore: 'Ver todas as avaliações no Google →',
    crossSellTitle: 'Descubra os nossos outros serviços',
    crossSellDesc: 'Tudo o que um hispanófono precisa na Suíça, sob o mesmo teto.',
    finalTitle: 'Pare de pagar demais. Comece a poupar hoje.',
    finalDesc: 'Cada mês sem rever o seu seguro é dinheiro perdido.',
    finalCta: 'Consulta gratuita por WhatsApp',
    finalBack: 'Ver serviços ↑',
  },

  digitalPage: {
    seoTitle: 'Soluções Digitais Avançadas - Desenvolvimento Web, CRM, IA & Marketing | Punto Hispano',
    seoDesc: 'Transformação digital completa para empresas na Suíça: desenvolvimento web profissional, CRM inteligente, chatbots IA, automação e marketing digital.',
    seoKeywords: 'soluções digitais suíça, desenvolvimento web profissional, CRM empresarial, inteligência artificial, chatbots, automação, marketing digital, SEO suíça',
    reviewsTitle: 'O QUE DIZEM OS NOSSOS',
    reviewsAccent: 'CLIENTES',
    reviewsDesc: 'Experiências reais de empresas que confiam no Punto Hispano',
  },

  emprendeDigitalPage: {
    seoTitle: 'Soluções Digitais para Empresas | Web, CRM, IA | Punto Hispano',
    seoDesc: 'Catálogo completo de serviços digitais: desenvolvimento web, CRM, chatbots IA, automação, marketing digital.',
    backLink: 'Voltar a Emprende',
    badge: 'Catálogo de Serviços',
    title: 'Soluções Digitais',
    subtitle: 'Serviços tecnológicos completos para fazer crescer o seu negócio no mundo digital. Do desenvolvimento web à inteligência artificial.',
    webTitle: 'Desenvolvimento Web',
    webDesc: 'Sites modernos, rápidos e otimizados para converter visitantes em clientes.',
    ecommerceTitle: 'E-commerce / Loja Online',
    ecommerceDesc: 'Lojas online completas com gestão de produtos, pagamentos e envios.',
    appTitle: 'Aplicações Móveis',
    appDesc: 'Apps nativas ou híbridas para iOS e Android com experiência premium.',
    chatbotTitle: 'Chatbots IA',
    chatbotDesc: 'Automatize o atendimento ao cliente 24/7 com inteligência artificial.',
    automationTitle: 'Automação de Processos',
    automationDesc: 'Otimize os seus fluxos de trabalho e poupe tempo em tarefas repetitivas.',
    marketingTitle: 'Marketing Digital',
    marketingDesc: 'Estratégias de marketing que geram resultados mensuráveis.',
    whatIncludes: 'O que inclui?',
    additionalTitle: 'Serviços Adicionais',
    additionalDesc: 'Complete o seu projeto com estes serviços especializados.',
    customDev: 'Desenvolvimento à medida',
    customDevDesc: 'Software personalizado para as suas necessidades',
    graphicDesign: 'Design Gráfico',
    graphicDesignDesc: 'Logos, branding e materiais corporativos',
    seoAudit: 'Auditoria SEO',
    seoAuditDesc: 'Análise completa da sua presença online',
    emailMarketing: 'Email Marketing',
    emailMarketingDesc: 'Campanhas de email automatizadas',
    socialMedia: 'Redes Sociais',
    socialMediaDesc: 'Gestão e conteúdo para redes sociais',
    techConsulting: 'Consultoria Tech',
    techConsultingDesc: 'Consultoria em tecnologia e transformação digital',
    ctaTitle: 'Precisa de algo diferente?',
    ctaDesc: 'Se não encontra exatamente o que procura, conte-nos a sua ideia e criaremos uma solução personalizada.',
    ctaSend: 'Enviar o Meu Projeto',
    ctaConsult: 'Consulta Gratuita',
  },

  viviendasPage: {
    seoTitle: 'Aluguer de Quartos na Suíça | Punto Hispano',
    seoDesc: 'Quartos mobilados na Suíça com WiFi, aquecimento e serviços incluídos. Contratos flexíveis. Atendimento em espanhol.',
    badgeLoading: 'A carregar...',
    badgeAvailable: 'alojamentos disponíveis',
    badgeComingSoon: 'Novos alojamentos em breve',
    heroTitle: 'Encontre a sua casa na Suíça',
    heroDesc: 'Quartos e apartamentos mobilados para hispanófonos. Tudo incluído, contratos flexíveis, suporte em espanhol.',
    where: 'Onde?',
    allCities: 'Todas as cidades',
    checkIn: 'Entrada',
    checkOut: 'Saída',
    guests: 'Hóspedes',
    guestsAny: 'Qualquer',
    guestsPerson: 'pessoa',
    guestsPersons: 'pessoas',
    guestsPlus: '4+ pessoas',
    search: 'Pesquisar',
    insurance: 'Seguro completo',
    noDeposit: 'Sem depósito',
    freeCancellation: 'Cancelamento gratuito',
    wifiIncluded: 'WiFi incluído',
    wifiDesc: 'Internet de alta velocidade',
    waterIncluded: 'Água incluída',
    waterDesc: 'Sem custos adicionais',
    heating: 'Aquecimento',
    heatingDesc: 'Climatização completa',
    spanishSupport: 'Suporte espanhol',
    spanishSupportDesc: 'Atenção personalizada',
    filterAll: 'Todos',
    filterRoom: 'Quarto',
    filterDouble: 'Duplo',
    filterStudio: 'Estúdio',
    filterApartment: 'Apartamento completo',
    sortRecommended: 'Recomendados',
    sortPriceAsc: 'Preço: menor para maior',
    sortPriceDesc: 'Preço: maior para menor',
    sortNewest: 'Mais recentes',
    searching: 'A pesquisar...',
    showing: 'A mostrar',
    accommodations: 'alojamentos',
    noAccommodations: 'Sem alojamentos disponíveis de momento',
    sortBy: 'Ordenar por:',
    whyChooseUs: 'Porquê escolher-nos?',
    bestOption: 'A melhor opção para hispanófonos na Suíça',
  },

  vehiculosPage: {
    seoTitle: 'Aluguer de Veículos na Suíça | Comparador de Preços | Punto Hispano',
    seoDesc: 'Compare e reserve carros de aluguer na Suíça. Seguro completo, quilómetros ilimitados e atendimento em espanhol.',
    badgeText: 'Comparador de Aluguer',
    heroTitle: 'Encontre o seu veículo ideal',
    heroDesc: 'Compare preços e reserve online. Seguro incluído, quilómetros ilimitados e atendimento em espanhol.',
    trustInsurance: 'Seguro completo sem franquia',
    trustKm: 'Quilómetros ilimitados incluídos',
    trustGps: 'GPS e assistência 24/7',
    trustSpanish: 'Atendimento 100% em espanhol',
    loading: 'A carregar...',
    loadingFleet: 'A carregar frota disponível...',
    errorTitle: 'Erro ao carregar os veículos',
    errorDesc: 'Por favor tente novamente mais tarde',
    showing: 'Mostrando',
    vehiclesAvailable: 'veículos disponíveis',
    noVehiclesTitle: 'Sem veículos para estas datas',
    noVehiclesDesc: 'Tente alterar as datas da sua pesquisa ou selecione outro local de recolha.',
    changeDates: 'Alterar datas',
    clearFilters: 'Limpar filtros',
    needHelp: 'Precisa de ajuda personalizada?',
    contactWhatsapp: 'Contactar por WhatsApp',
    filters: 'Filtros',
    ctaTitle: 'Pronto para alugar o seu carro?',
    ctaDesc: 'Reserve agora com quilómetros ilimitados, GPS incluído e seguro completo.',
    ctaWhatsapp: 'Reservar por WhatsApp',
    ctaContact: 'Formulário de Contacto',
  },

  relocationPage: {
    seoTitle: 'Pack Relocation Suíça | Emigrar Sem Riscos | Punto Hispano',
    seoDesc: 'Serviço completo de relocation na Suíça. Alojamento verificado, trâmites completos, acompanhamento presencial. Desde 349 CHF.',
    seoKeywords: 'relocation suíça, emigrar suíça, mudança suíça, pack relocation, punto hispano',
    breadHome: 'Início',
    breadServices: 'Serviços',
    breadRelocation: 'Pack Relocation',
    badge1: '100% Sucesso',
    badge2: '+50 Famílias',
    badge3: '+10 Anos',
    heroTitle: 'Emigrar para a Suíça',
    heroAccent: 'Sem Riscos',
    heroDesc: 'A única consultoria que garante alojamento verificado, documentação completa e acompanhamento desde antes da sua chegada até à integração total.',
    heroCta: 'Ver Packs',
    heroWhatsapp: 'Consulta Gratuita',
    empathyTitle: 'Isto soa-lhe familiar?',
    empathyDesc: 'Emigrar é emocionante, mas também pode ser avassalador',
    empathy1Title: 'Chegar sem saber por onde começar',
    empathy1Desc: 'Não fala a língua, não conhece o sistema e cada trâmite parece um labirinto.',
    empathy2Title: 'Medo de burlas imobiliárias',
    empathy2Desc: 'Agências fantasma, depósitos perdidos e contratos abusivos são mais comuns do que pensa.',
    empathy3Title: 'Papéis que não entende',
    empathy3Desc: 'Autorização B, seguro obrigatório, registo comunal... tudo em alemão, francês ou italiano.',
    empathy4Title: 'Sentir-se só ao chegar',
    empathy4Desc: 'Sem rede de apoio, sem saber a quem perguntar ou onde ir quando algo corre mal.',
    empathyBottom: 'Se algo disto lhe soa familiar, não está sozinho.',
    empathyBottomBold: 'Mais de 50 famílias',
    empathyBottomEnd: 'já emigraram connosco sem passar por nada disto.',
    packsTitle: 'Pacotes de Relocation',
    packsDesc: 'Escolha o pacote perfeito para a sua mudança para a Suíça',
    packMostSold: '⭐ Mais Vendido',
    processTitle: 'Assim de Simples',
    step1Title: 'Conte-nos a sua situação',
    step1Desc: 'Fazemos uma avaliação gratuita para entender o que precisa.',
    step2Title: 'Preparamos tudo',
    step2Desc: 'Documentação, alojamento verificado, seguros e trâmites: tudo pronto antes da sua chegada.',
    step3Title: 'Chega e desfruta',
    step3Desc: 'Acompanhamo-lo presencialmente no primeiro dia e oferecemos suporte estendido.',
    faqTitle: 'Perguntas Frequentes',
    crossSellTitle: 'Serviços Complementares',
    finalTitle: 'Pronto para dar o passo?',
    finalDesc: 'Mais de 50 famílias já emigraram com a nossa ajuda.',
    finalCta: 'Iniciar a sua Relocation',
  },

  emprendePage: {
    seoTitle: 'Empreenda com Punto Hispano | Desenvolvimento Web & Soluções Digitais',
    seoDesc: 'Impulsione seu negócio digital: desenvolvimento web, CRM, IA, automação e marketing.',
    badge: 'Soluções Digitais',
    heroTitle1: 'Impulsione Seu',
    heroTitle2: ' Negócio Digital',
    heroDesc: 'Desenvolvimento web, inteligência artificial, automação e marketing digital. Transformamos suas ideias em soluções tecnológicas.',
    ctaIdea: 'Conte-nos Sua Ideia',
    ctaSolutions: 'Ver Soluções',
    servicesTitle: 'Nossos Serviços Digitais',
    servicesDesc: 'Soluções tecnológicas completas para fazer seu negócio crescer.',
    svc1Title: 'Desenvolvimento Web', svc1Desc: 'Sites modernos e rápidos otimizados para converter visitantes em clientes.', svc1F1: 'Design responsivo', svc1F2: 'SEO incluído', svc1F3: 'CMS integrado',
    svc2Title: 'Chatbots com IA', svc2Desc: 'Automatize o atendimento ao cliente 24/7 com IA.', svc2F1: 'Respostas naturais', svc2F2: 'Multi-idioma', svc2F3: 'Integração CRM',
    svc3Title: 'Automação', svc3Desc: 'Otimize seus processos de negócio.', svc3F1: 'Workflows', svc3F2: 'Integrações', svc3F3: 'Relatórios automáticos',
    svc4Title: 'Apps Mobile', svc4Desc: 'Aplicativos nativos ou híbridos para iOS e Android.', svc4F1: 'UI/UX premium', svc4F2: 'Notificações push', svc4F3: 'Modo offline',
    svc5Title: 'Marketing Digital', svc5Desc: 'Estratégias de marketing com resultados mensuráveis.', svc5F1: 'SEO & SEM', svc5F2: 'Redes Sociais', svc5F3: 'Email Marketing',
    svc6Title: 'E-commerce', svc6Desc: 'Lojas online completas com pagamentos e gestão de estoque.', svc6F1: 'Pagamentos seguros', svc6F2: 'Gestão de estoque', svc6F3: 'Envios automatizados',
    processTitle: 'Como Trabalhamos',
    processDesc: 'Um processo claro e transparente da sua ideia ao produto final.',
    proc1: 'Conte-nos sua ideia', proc1Desc: 'Descreva seu projeto e objetivos.',
    proc2: 'Análise e proposta', proc2Desc: 'Avaliamos a viabilidade técnica e apresentamos uma proposta detalhada.',
    proc3: 'Desenvolvimento', proc3Desc: 'Construímos sua solução com metodologias ágeis.',
    proc4: 'Lançamento', proc4Desc: 'Implantamos seu projeto e o acompanhamos no lançamento.',
    card1Title: 'Compartilhe Sua Ideia', card1Desc: 'Tem um projeto em mente? Conte-nos.', card1Cta: 'Enviar Ideia',
    card2Title: 'Ganhe Dinheiro Online', card2Desc: 'Aprenda a monetizar suas habilidades.', card2Cta: 'Ver Guias',
    card3Title: 'Colabore Conosco', card3Desc: 'Junte-se ao nosso programa de parceiros.', card3Cta: 'Ser Parceiro',
    finalTitle: 'Pronto para Digitalizar seu Negócio?',
    finalDesc: 'Entre em contato hoje e descubra como podemos ajudá-lo a crescer no mundo digital.',
    finalWhatsapp: 'Contato via WhatsApp',
    finalSchedule: 'Agendar Consulta',
  },

  politicasPage: {
    seoTitle: 'Políticas & Documentos Legais | Punto Hispano',
    seoDesc: 'Documentação legal, políticas de privacidade, cookies e termos de uso do Punto Hispano.',
    title: 'Políticas & Documentos Legais',
    subtitle: 'Transparência e conformidade regulatória em todos os nossos serviços',
    commitmentTitle: 'Compromisso de Transparência',
    commitmentDesc: 'No Punto Hispano nos comprometemos a manter total transparência sobre como operamos, como tratamos seus dados e quais direitos você tem como usuário.',
    avisoLegal: 'Aviso Legal',
    avisoLegalDesc: 'Informações sobre a entidade titular deste site, condições gerais de uso e direitos de propriedade intelectual.',
    privacidad: 'Política de Privacidade',
    privacidadDesc: 'Informações detalhadas sobre como coletamos, usamos, compartilhamos e protegemos seus dados pessoais.',
    cookies: 'Política de Cookies',
    cookiesDesc: 'Informações sobre quais cookies usamos, para que servem e como configurar suas preferências.',
    gdpr: 'Política RGPD',
    gdprDesc: 'Informações completas sobre proteção de dados pessoais segundo o RGPD e seus direitos como usuário.',
    questionTitle: 'Tem alguma dúvida adicional?',
    questionDesc: 'Se tiver perguntas sobre nossas políticas, entre em contato com nosso Encarregado de Proteção de Dados em',
    lastUpdate: 'Última atualização das nossas políticas: 5 de maio de 2025',
  },

  faqPage: {
    seoTitle: 'Perguntas Frequentes | Punto Hispano',
    seoDesc: 'Respostas às perguntas mais frequentes sobre nossos serviços na Suíça.',
    title: 'Perguntas Frequentes',
    subtitle: 'Respostas às consultas mais comuns sobre nossos serviços',
    notFound: 'Não encontrou resposta? Não hesite em nos contatar.',
    phone: 'Telefone',
    email: 'Email',
    cat1: 'Gerais',
    cat2: 'Gestão & Administração',
    cat3: 'Assessoria Jurídica',
    cat4: 'Cursos de Idiomas',
    cat5: 'Traduções Oficiais',
    cat6: 'Web Design & Hospedagem',
    cat7: 'Consultoria de Seguros',
    cat8: 'Soluções Digitais',
    q1_1: 'Que serviços o Punto Hispano oferece?', a1_1: 'O Punto Hispano oferece uma ampla gama de serviços profissionais: gestão administrativa, assessoria jurídica, cursos de idiomas, traduções oficiais, web design, consultoria de seguros e soluções digitais.',
    q1_2: 'Em quais idiomas oferecem seus serviços?', a1_2: 'Nossos serviços estão disponíveis principalmente em espanhol, mas também atendemos em alemão, inglês e italiano.',
    q1_3: 'Como posso solicitar um orçamento?', a1_3: 'Pode solicitar um orçamento pelo nosso formulário de contato, ligando para +41 77 231 72 88 ou enviando email para info@puntohispano.ch.',
    q1_4: 'Têm serviços personalizados para empresas?', a1_4: 'Sim, oferecemos soluções personalizadas para empresas em todas as nossas áreas de serviço.',
    q1_5: 'Onde fica o escritório principal?', a1_5: 'Nosso escritório principal fica na Thurgauerstrasse 117, 8152 Opfikon, Zurique, Suíça.',
    q2_1: 'O que inclui o serviço de criação de empresas?', a2_1: 'Nosso serviço inclui consultoria sobre forma jurídica, preparação de documentos, registro comercial, inscrição fiscal e procedimentos de segurança social.',
    q2_2: 'Como funciona o planejamento fiscal?', a2_2: 'Realizamos uma análise personalizada da sua situação fiscal e aconselhamos sobre deduções e benefícios fiscais aplicáveis.',
    q2_3: 'Podem gerenciar minha declaração de impostos?', a2_3: 'Sim, oferecemos serviço completo de gestão de declarações fiscais para particulares.',
    q3_1: 'Quais documentos preciso para reagrupamento familiar?', a3_1: 'Para reagrupamento familiar são necessários: autorização de residência, certidões de casamento/nascimento legalizadas, comprovante de meios financeiros e contrato de aluguel.',
    q3_2: 'Oferecem assessoria em direito do trabalho suíço?', a3_2: 'Sim, fornecemos assessoria completa em direito do trabalho suíço, incluindo revisão de contratos, demissões e disputas trabalhistas.',
    q4_1: 'Qual é o preço dos cursos de alemão?', a4_1: 'Os preços variam conforme nível e modalidade. De CHF 40/hora em grupo a CHF 90/sessão particular.',
    q4_2: 'Posso ter uma aula experimental?', a4_2: 'Sim, oferecemos uma aula experimental gratuita para conhecer nossa metodologia.',
    q5_1: 'Suas traduções são válidas para trâmites oficiais?', a5_1: 'Sim, nossas traduções oficiais são realizadas por tradutores juramentados e são válidas perante órgãos oficiais.',
    q5_2: 'Quanto tempo demora uma tradução juramentada?', a5_2: 'Documentos padrão levam geralmente 2-3 dias úteis. Serviço expresso disponível para urgências.',
    q6_1: 'O que inclui o pacote de site profissional?', a6_1: 'Inclui: design personalizado de 5-7 páginas, design responsivo, SEO básico, integração Analytics, formulário de contato, hospedagem um ano e manutenção 3 meses.',
    q6_2: 'Posso atualizar meu site sozinho depois?', a6_2: 'Sim, implementamos um CMS que permite atualizar textos, imagens e seções facilmente.',
    q7_1: 'Como posso reduzir meu prêmio do seguro saúde?', a7_1: 'Existem várias estratégias: ajustar a franquia, escolher modelo HMO, verificar subsídios cantonais ou combinar diferentes coberturas.',
    q7_2: 'Quais seguros são obrigatórios na Suíça?', a7_2: 'O seguro saúde básico (LAMal) é obrigatório para todos os residentes. O seguro de responsabilidade civil é obrigatório para proprietários de veículos.',
    q8_1: 'O que é um CRM e como pode beneficiar meu negócio?', a8_1: 'Um CRM permite gerenciar centralmente as relações com clientes com vantagens como melhor organização de dados e automação de vendas.',
    q8_2: 'Que soluções de IA oferecem para pequenas empresas?', a8_2: 'Oferecemos chatbots 24/7, automação de tarefas administrativas, análise preditiva de dados e assistentes virtuais de agendamento.',
  },

  contactoPage: {
    seoTitle: 'Contacto | Administração & Consultoria na Suíça | Punto Hispano',
    seoDesc: 'Escreva-nos por WhatsApp ou email ou marque uma consulta em Zurique. Resposta rápida.',
    heroTitle: 'Vamos Conversar',
    heroDesc: 'A nossa equipa de profissionais bilingues está pronta para o ajudar. Escolha o seu método de contacto preferido.',
    whatsappBtn: 'WhatsApp Direto',
    formBtn: 'Formulário de Contacto',
    formTitle: 'Formulário de Contacto',
    successTitle: 'Mensagem Enviada!',
    successDesc: 'Obrigado por nos contactar. Recebemos a sua mensagem e responderemos dentro de 24 horas.',
    sendAnother: 'Enviar outra mensagem',
    labelName: 'Nome Completo',
    placeholderName: 'Insira o seu nome completo',
    labelEmail: 'Endereço de Email',
    placeholderEmail: 'seu.email@exemplo.com',
    labelPhone: 'Telefone (opcional)',
    placeholderPhone: '+41 XX XXX XX XX',
    labelService: 'Área de Serviço',
    selectService: 'Selecione uma área',
    optGestoria: 'Administração & Fiscal',
    optLegal: 'Assessoria Jurídica',
    optIdiomas: 'Cursos de Idiomas',
    optSeguros: 'Seguros & Previdência',
    optDigital: 'Soluções Digitais',
    optOther: 'Outro',
    labelMessage: 'A Sua Mensagem',
    placeholderMessage: 'Conte-nos como podemos ajudá-lo...',
    sending: 'A enviar mensagem...',
    sendBtn: 'Enviar Mensagem',
    toastSuccess: 'Formulário enviado',
    toastSuccessDesc: 'Recebemos a sua mensagem. Entraremos em contacto em breve.',
    toastError: 'Erro ao enviar',
    toastErrorDesc: 'Ocorreu um problema ao enviar a sua mensagem. Por favor, tente novamente.',
    infoTitle: 'Informações de Contacto',
    infoDesc: 'A nossa equipa multilingue está pronta para o assistir em português, espanhol e inglês.',
    officeTitle: 'O Nosso Escritório',
    phoneTitle: 'Telefone',
    whatsappTitle: 'WhatsApp Direto',
    emailTitle: 'Email',
    hoursTitle: 'Horário de Funcionamento',
    monFri: 'Segunda - Sexta',
    sat: 'Sábado',
    sun: 'Domingo',
    closed: 'Fechado',
    needHelp: 'Precisa de ajuda imediata?',
    needHelpDesc: 'Contacte-nos diretamente por WhatsApp para assistência rápida',
    validName: 'O nome deve ter pelo menos 2 caracteres',
    validEmail: 'Por favor insira um endereço de email válido',
    validService: 'Por favor selecione uma área de serviço',
    validMessage: 'A mensagem deve ter pelo menos 10 caracteres',
  },

  contactoFormPage: {
    seoTitle: 'Formulário de Contacto | Punto Hispano',
    seoDesc: 'Contacte-nos para informações sobre os nossos serviços. Respondemos em 24-48 horas úteis.',
    title: 'Formulário de Contacto',
    subtitle: 'Preencha o formulário abaixo para nos enviar a sua consulta. A nossa equipa responderá o mais brevemente possível.',
    successTitle: 'Mensagem Enviada!',
    successDesc: 'Obrigado por nos contactar. Responderemos dentro de 24-48 horas úteis.',
    sendAnother: 'Enviar outra mensagem',
    labelName: 'Nome completo',
    placeholderName: 'Insira o seu nome',
    labelEmail: 'Endereço de email',
    labelPhone: 'Telefone (opcional)',
    placeholderPhone: 'O seu número de telefone',
    labelService: 'Área de serviço',
    selectService: 'Selecione uma área',
    optGestoria: 'Administração',
    optLegal: 'Assessoria Jurídica',
    optIdiomas: 'Cursos de Idiomas',
    optSeguros: 'Seguros & Previdência',
    optDigital: 'Soluções Digitais',
    optCoches: 'Aluguel de Carros',
    optViviendas: 'Aluguel de Habitação',
    labelMessage: 'Mensagem',
    placeholderMessage: 'Como podemos ajudá-lo?',
    sending: 'A enviar...',
    sendBtn: 'Enviar Mensagem',
    privacyText: 'Ao enviar este formulário, aceita a nossa',
    privacyLink: 'política de privacidade',
    privacyEnd: 'e o tratamento dos seus dados para responder à sua consulta.',
    fastResponse: 'Resposta rápida',
    fastResponseDesc: '24-48h úteis',
    noCommitment: 'Sem compromisso',
    noCommitmentDesc: 'Orçamentos personalizados',
    spanishSupport: 'Suporte multilingue',
    spanishSupportDesc: 'Equipa multilingue profissional',
  },

  oficinasPage: {
    seoTitle: 'Escritório Opfikon | Punto Hispano',
    seoDesc: 'Visite o nosso escritório em Opfikon, Zurique. Localização, horários, transportes.',
    heroTitle: 'O Nosso Escritório em Opfikon',
    heroDesc: 'Visite-nos no centro comercial TMC, a minutos do centro de Zurique.',
    howToFind: 'Como Nos Encontrar — Passo a Passo',
    step1Title: 'Procure o edifício TMC',
    step1Desc: 'É um centro comercial na Thurgauerstrasse 117. Verá o letreiro "TMC" na fachada.',
    step2Title: 'Entre e vá em frente',
    step2Desc: 'Entre pela porta principal e vá em frente até ver um café.',
    step3Title: 'Suba ao 1º andar',
    step3Desc: 'Junto ao café encontrará o elevador. Suba ao primeiro andar.',
    step4Title: 'Vire à direita',
    step4Desc: 'Ao sair do elevador, vire à direita. O nosso escritório é o 181.',
    tmcNote: 'Estamos dentro do TMC (Trade Mart Center), um edifício de showrooms e escritórios.',
    enlargeMap: 'Ampliar Mapa',
    addressTitle: 'Morada',
    phoneTitle: 'Telefone',
    emailTitle: 'Email',
    hoursTitle: 'Horário de Funcionamento',
    appointmentsTitle: 'Marcações',
    appointmentsDesc: 'Para um melhor atendimento, recomendamos marcar previamente.',
    requestAppointment: 'Solicitar Marcação',
    howToGet: 'Como Chegar',
    train: 'Comboio',
    trainDesc: 'Estação de Opfikon, 5 minutos a pé',
    bus: 'Autocarro',
    busDesc: 'Linhas 759, 781 - Paragem Thurgauerstrasse',
    car: 'Automóvel',
    carDesc: 'Estacionamento disponível no edifício',
    airport: 'Do aeroporto',
    airportDesc: '10 minutos de táxi ou autocarro direto',
    parkingTitle: 'Estacionamento',
    parkingDesc: 'O edifício TMC dispõe de estacionamento por hora para clientes. Alternativamente, estacionamento público nas proximidades.',
    additionalInfo: 'Informações Adicionais',
    accessibilityTitle: 'Acessibilidade',
    accessibilityDesc: 'Os nossos escritórios têm acesso para pessoas com mobilidade reduzida. O edifício tem elevadores e rampas.',
    walkInsTitle: 'Visitas sem marcação',
    walkInsDesc: 'Recomendamos marcação prévia, mas aceitamos visitas conforme disponibilidade.',
    nearbyTitle: 'Serviços próximos',
    nearbyDesc: 'Dentro do edifício TMC encontrará um café onde pode esperar confortavelmente.',
    otherContactTitle: 'Prefere contactar-nos de outra forma?',
    otherContactDesc: 'Se não pode visitar-nos pessoalmente, temos outras opções de contacto.',
    contactForm: 'Formulário de Contacto',
    whatsappChat: 'WhatsApp & Chat',
    days: ['Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado', 'Domingo'],
    satHours: '10:00 - 14:00 (com marcação)',
    closed: 'Fechado',
  },

  quienesSomosPage: {
    seoTitle: 'Quem Somos - Punto Hispano | Serviços Profissionais na Suíça',
    seoDesc: 'Conheça o Punto Hispano: 12+ anos ao serviço da comunidade na Suíça. Administração, seguros, jurídico, idiomas e serviços digitais.',
    badge: 'Sobre Nós',
    heroTitle: 'Punto Hispano:',
    heroAccent: 'A sua ponte entre a Suíça e o mundo',
    heroDesc: 'Desde 2013, facilitamos a integração e o sucesso em território suíço.',
    stat1: 'Clientes Satisfeitos',
    stat2: 'Procedimentos Concluídos',
    stat3: 'Empresas Criadas',
    stat4: 'Anos de Experiência',
    missionBtn: 'A Nossa Missão & Visão',
    contactBtn: 'Contactar',
    teamPhoto: 'A Nossa Equipa',
    teamPhotoDesc: 'Profissionais dedicados ao seu sucesso',
    historyTitle: 'A Nossa História',
    historySubtitle: 'Um caminho de crescimento e compromisso',
    historyDesc: 'Descubra como o Punto Hispano evoluiu desde os seus inícios até se tornar a referência na Suíça.',
    timeline2013Title: 'Os inícios',
    timeline2013Desc: 'Santiago Castillo, o fundador, começou na Suíça com seguros e 3º pilar.',
    timeline2019Title: 'Serviços sem escritório',
    timeline2019Desc: 'O Punto Hispano começou a oferecer serviços profissionais à comunidade.',
    timeline2023Title: 'Abertura do escritório',
    timeline2023Desc: 'O Punto Hispano abriu o seu escritório físico, um marco importante.',
    timeline2025Title: 'Expansão contínua',
    timeline2025Desc: 'Continuamos a expandir os nossos serviços e a consolidar a nossa posição de referência.',
    teamTitle: 'A Nossa Equipa & Escritório',
    teamSubtitle: 'As pessoas por trás do Punto Hispano',
    teamDesc: 'Conheça Santiago Castillo, o nosso fundador, e a equipa profissional.',
    founderBadge: 'Fundador',
    valuesTitle: 'Os Nossos Valores',
    valuesSubtitle: 'Os princípios que nos guiam',
    valuesDesc: 'Cada valor representa um compromisso real com os nossos clientes e a comunidade.',
    val1Title: 'Proximidade',
    val1Desc: 'Atenção personalizada e adaptada a cada cliente.',
    val2Title: 'Profissionalismo',
    val2Desc: 'Rigor, excelência e melhoria contínua.',
    val3Title: 'Transparência',
    val3Desc: 'Comunicação clara e honesta.',
    val4Title: 'Inovação',
    val4Desc: 'Busca constante de soluções criativas e eficientes.',
    val5Title: 'Compromisso',
    val5Desc: 'Dedicação absoluta à satisfação e sucesso dos clientes.',
    val6Title: 'Integração',
    val6Desc: 'Facilitamos a ligação entre culturas.',
    ctaTitle: 'Pronto para dar o primeiro passo?',
    ctaDesc: 'Contacte-nos hoje para uma consulta gratuita.',
    ctaBtn: 'Solicitar Consulta Gratuita',
    ctaSecondary: 'Ver os Nossos Serviços',
  },

  misionVisionPage: {
    seoTitle: 'Missão & Visão - Punto Hispano | Líder em Serviços Profissionais na Suíça',
    seoDesc: 'Descubra a missão, visão e valores do Punto Hispano: 12+ anos a liderar serviços profissionais na Suíça.',
    badge: 'O Nosso Propósito',
    heroTitle: 'Missão &',
    heroAccent: 'Visão',
    heroDesc: 'Descubra o que nos motiva a ser a referência em serviços profissionais na Suíça',
    stat1: 'Clientes satisfeitos',
    stat2: 'Anos de experiência',
    stat3: 'Compromisso com a qualidade',
    stat4: 'Pilares de serviço',
    missionTitle: 'A Nossa Missão',
    missionSubtitle: 'O que fazemos todos os dias',
    missionText1: 'Fornecer serviços profissionais completos da mais alta qualidade à comunidade na Suíça.',
    missionText2: 'Comprometemo-nos a ser uma ponte fiável entre culturas.',
    missionPoints: ['Serviços profissionais completos', 'Facilitamos a integração na Suíça', 'Desenvolvimento profissional e bem-estar pessoal', 'Soluções eficientes e personalizadas', 'Ponte fiável entre culturas', 'Acompanhamento próximo no seu idioma'],
    commitmentTitle: 'Compromisso Diário',
    commitmentDesc: 'Todos os dias trabalhamos para concretizar a nossa missão.',
    visionTitle: 'A Nossa Visão',
    visionSubtitle: 'Para onde nos dirigimos',
    visionText1: 'Ser reconhecidos como a empresa líder em serviços profissionais na Suíça.',
    visionText2: 'Aspiramos a transformar a experiência do cliente na Suíça.',
    visionPoints: ['Empresa líder em serviços', 'Excelência e inovação tecnológica', 'Abordagem humana e personalizada', 'Integração perfeita de serviços tradicionais e digitais', 'Ecossistema completo de soluções', 'Transformação da experiência do cliente'],
    futureTitle: 'Futuro Brilhante',
    futureDesc: 'Construímos o futuro dos serviços profissionais na Suíça.',
    valuesTitle: 'Valores que Nos Definem',
    valuesSubtitle: 'Os princípios fundamentais que guiam cada decisão.',
    val1Title: 'Proximidade',
    val1Desc: 'Tratamento pessoal e humano',
    val2Title: 'Confiança',
    val2Desc: 'Transparência total',
    val3Title: 'Excelência',
    val3Desc: 'Qualidade superior',
    val4Title: 'Inovação',
    val4Desc: 'Tecnologia avançada',
    ctaTitle: 'Pronto para fazer parte da nossa história?',
    ctaDesc: 'Junte-se a mais de 2500 clientes que confiam no Punto Hispano.',
    ctaBtn: 'Consulta Gratuita',
    ctaSecondary: 'Ver Serviços',
  },

  valoresPage: {
    seoTitle: 'Valores Corporativos - Punto Hispano | Excelência, Confiança & Inovação',
    seoDesc: 'Descubra os valores fundamentais do Punto Hispano: excelência, confiança, especialização, integridade, inovação e empatia.',
    badge: 'A Nossa Filosofia',
    heroTitle: 'Os Nossos',
    heroAccent: 'Valores',
    heroDesc: 'Os princípios fundamentais que definem a nossa identidade e guiam cada decisão.',
    stat1: 'Anos de experiência',
    stat2: 'Clientes satisfeitos',
    stat3: 'Pilares de serviço',
    stat4: 'Compromisso com a qualidade',
    val1Title: 'Excelência',
    val1Desc: 'Procuramos a mais alta qualidade em cada serviço.',
    val2Title: 'Confiança',
    val2Desc: 'Construímos relações duradouras baseadas na transparência e honestidade.',
    val3Title: 'Especialização',
    val3Desc: 'Mantemos um conhecimento profundo e atualizado das nossas áreas de serviço.',
    val4Title: 'Integridade',
    val4Desc: 'Agimos com retidão e ética profissional.',
    val5Title: 'Inovação',
    val5Desc: 'Integramos constantemente novas tecnologias e métodos.',
    val6Title: 'Empatia',
    val6Desc: 'Compreendemos as necessidades e circunstâncias únicas de cada cliente.',
    learnMore: 'Saber mais',
    commitmentTitle: 'O Nosso Compromisso Inabalável',
    commitmentText1: 'No Punto Hispano, estes valores não são meras palavras, mas princípios vivos.',
    commitmentText2: 'Comprometemo-nos firmemente a manter os mais altos padrões de qualidade e ética profissional.',
    promiseLabel: 'A nossa promessa:',
    promiseText: 'Todos os dias trabalhamos para ser a referência de confiança, excelência e proximidade que a comunidade na Suíça merece e precisa.',
    meetTeam: 'Conheça a nossa equipa',
    actionTitle: 'Valores em Ação',
    actionSubtitle: 'Descubra como os nossos valores se traduzem em benefícios tangíveis.',
    qualityTitle: 'Garantia de Qualidade',
    qualityDesc: 'O nosso compromisso com a excelência reflete-se em cada serviço que prestamos.',
    qualityItems: ['Atenção personalizada e dedicada', 'Monitorização contínua de todos os processos', 'Transparência total na nossa gestão'],
    closenessTitle: 'Proximidade Humana',
    closenessDesc: 'Entendemos que por trás de cada procedimento há uma pessoa com sonhos e necessidades únicos.',
    closenessItems: ['Comunicação na sua língua materna', 'Compreensão da sua cultura e contexto', 'Apoio emocional em processos complexos'],
  },

  carrerasPage: {
    seoTitle: 'Trabalhe Connosco no Punto Hispano Suíça',
    seoDesc: 'Descubra oportunidades de carreira no Punto Hispano: administração, jurídico, idiomas, seguros e digital.',
    badge: 'Oportunidades de Carreira',
    heroTitle: 'Trabalhe',
    heroAccent: 'Connosco',
    heroDesc: 'Junte-se à equipa líder em serviços profissionais na Suíça.',
    stat1: 'Clientes satisfeitos',
    stat2: 'Anos de experiência',
    stat3: 'Profissionais + colaboradores externos',
    stat4: 'Áreas de especialização',
    benefitsTitle: 'Porquê escolher o Punto Hispano?',
    benefitsSubtitle: 'Descubra as vantagens de fazer parte da nossa equipa profissional',
    ben1Title: 'Ambiente Multicultural',
    ben1Desc: 'Trabalhe num ambiente colaborativo com profissionais de diversas nacionalidades',
    ben2Title: 'Crescimento Profissional',
    ben2Desc: 'Oportunidades reais de desenvolvimento e promoção interna',
    ben3Title: 'Formação Contínua',
    ben3Desc: 'Apoio para certificações e atualização profissional constante',
    ben4Title: 'Equilíbrio Vida-Trabalho',
    ben4Desc: 'Horários flexíveis e respeito pelo seu tempo pessoal',
    ben5Title: 'Benefícios Sociais',
    ben5Desc: 'Seguro de saúde, planos de previdência e benefícios adicionais',
    ben6Title: 'Reconhecimento',
    ben6Desc: 'Sistema de incentivos e reconhecimento por desempenho excecional',
    joinTitle: 'Junte-se à Equipa',
    joinSubtitle: 'A sua próxima oportunidade profissional espera por si',
    joinText1: 'No Punto Hispano procuramos talento comprometido com atitude positiva e vocação de serviço.',
    joinText2: 'Faça parte da empresa líder em serviços profissionais na Suíça.',
    processTitle: 'Processo de Seleção:',
    processSteps: ['Envio de CV e carta de apresentação', 'Revisão de candidaturas e pré-seleção', 'Entrevista inicial com RH', 'Entrevista técnica com a equipa', 'Proposta de contratação'],
    sendCV: 'Envie o seu CV',
    areasTitle: 'Áreas de Especialização',
    areasSubtitle: 'Descubra as diferentes áreas onde pode desenvolver a sua carreira',
    area1Title: 'Administração Fiscal',
    area1Desc: 'Especialistas em declarações fiscais, contabilidade e consultoria tributária.',
    area1Req: 'Experiência em fiscalidade suíça/internacional, licenciatura em gestão ou similar.',
    area2Title: 'Assessoria Jurídica',
    area2Desc: 'Profissionais do direito especializados em imigração, trabalho, civil e comercial.',
    area2Req: 'Licenciatura em direito, experiência em assessoria jurídica internacional.',
    area3Title: 'Ensino de Idiomas',
    area3Desc: 'Professores nativos para aulas individuais e em grupo.',
    area3Req: 'Habilitação oficial para ensino de idiomas, certificações (DELE, Goethe, Cambridge).',
    area4Title: 'Consultoria de Seguros',
    area4Desc: 'Consultores especializados em seguro de saúde, vida e planos de previdência.',
    area4Req: 'Certificação como consultor de seguros, experiência no mercado suíço.',
    area5Title: 'Desenvolvimento Digital',
    area5Desc: 'Designers e desenvolvedores web, especialistas UX/UI e marketing digital.',
    area5Req: 'Formação técnica, portfolio de projetos, conhecimentos atualizados.',
    area6Title: 'Vendas & Marketing',
    area6Desc: 'Profissionais focados na captação de clientes e estratégias de posicionamento.',
    area6Req: 'Experiência comercial B2B, capacidades comunicativas excecionais.',
    reqLabel: 'Requisitos:',
  },

  notFoundPage: {
    title: 'Página não encontrada',
    desc: 'Desculpe, a página que procura não existe ou foi movida.',
    goHome: 'Voltar ao início',
  },

  recursosPage: {
    seoTitle: 'Recursos Gratuitos | Guias, Ferramentas & Webinars | Punto Hispano',
    seoDesc: 'Aceda a guias, calculadoras, webinars e recursos gratuitos para o seu sucesso na Suíça.',
    heroTitle: 'Centro de Recursos',
    heroSubtitle: 'Ferramentas, guias e materiais gratuitos para o seu sucesso na Suíça',
    searchPlaceholder: 'Pesquisar recursos...',
    filterAll: 'Todos',
    filterGuides: 'Guias',
    filterCalculators: 'Calculadoras',
    filterWebinars: 'Webinars',
    filterVideos: 'Vídeos',
    filterTemplates: 'Modelos',
    categoryAll: 'Todas as categorias',
    categoryLegal: 'Jurídico',
    categoryFiscal: 'Fiscal',
    categorySeguros: 'Seguros',
    categoryIdiomas: 'Idiomas',
    categoryDigital: 'Digital',
    sortPopular: 'Mais populares',
    sortRecent: 'Mais recentes',
    sortRating: 'Melhor avaliados',
    downloads: 'downloads',
    pages: 'páginas',
    downloadBtn: 'Descarregar',
    previewBtn: 'Pré-visualizar',
    featured: 'Destaque',
    new: 'Novo',
    noResults: 'Nenhum recurso encontrado com os filtros selecionados.',
    clearFilters: 'Limpar filtros',
    newsletterTitle: 'Quer receber novos recursos?',
    newsletterDesc: 'Subscreva e receba guias e ferramentas diretamente no seu email.',
    newsletterBtn: 'Subscrever',
    emailPlaceholder: 'seu@email.com',
  },

  guiasPracticasPage: {
    seoTitle: 'Guias Práticos | Recursos | Punto Hispano',
    seoDesc: 'Guias detalhados sobre procedimentos e processos na Suíça.',
    title: 'Guias Práticos',
    subtitle: 'Informações úteis para os seus procedimentos e gestões',
    readTime: 'Tempo de leitura',
    readGuide: 'Ler guia',
    faqTitle: 'Perguntas Frequentes sobre os nossos Guias',
  },

  whitepapersPage: {
    seoTitle: 'Whitepapers | Recursos Profissionais | Punto Hispano',
    seoDesc: 'Descarregue os nossos whitepapers especializados em fiscalidade, direito e transformação digital.',
    title: 'Whitepapers',
    subtitle: 'Documentos técnicos e guias profissionais',
    pages: 'páginas',
    published: 'Publicado',
    downloadPdf: 'Descarregar PDF',
    faqTitle: 'Perguntas Frequentes sobre os nossos Whitepapers',
  },

  videosWebinarsPage: {
    seoTitle: 'Vídeos & Webinars | Recursos Audiovisuais | Punto Hispano',
    seoDesc: 'Aceda aos nossos webinars e conteúdos audiovisuais sobre procedimentos, impostos e vida na Suíça.',
    title: 'Vídeos & Webinars',
    subtitle: 'Conteúdo audiovisual educativo e profissional',
    upcoming: 'Próximos',
    past: 'Anteriores',
    register: 'Registar',
    watchNow: 'Ver agora',
    duration: 'Duração',
    faqTitle: 'Perguntas Frequentes sobre os nossos Webinars',
  },

  colaboraPage: {
    seoTitle: 'Programa de Partners e Colaboradores | Punto Hispano',
    seoDesc: 'Junte-se ao nosso programa de parceiros: afiliados, parceiros tecnológicos e agências.',
    heroTitle: 'Programa de Partners e Colaboradores',
    heroDesc: 'Junte-se ao nosso ecossistema e cresça connosco.',
    backToEmprende: 'Voltar a Emprende',
    whyPartner: 'Porquê tornar-se Parceiro?',
    whyPartnerDesc: 'Benefícios exclusivos do nosso ecossistema de colaboração.',
    ben1Title: 'Comissões Atrativas',
    ben1Desc: 'Ganhe comissões competitivas por cada referência ou projeto conjunto.',
    ben2Title: 'Suporte Dedicado',
    ben2Desc: 'Equipa de suporte exclusiva para parceiros com prioridade.',
    ben3Title: 'Formação Contínua',
    ben3Desc: 'Acesso a recursos e formações exclusivas para parceiros.',
    ben4Title: 'Crescimento Conjunto',
    ben4Desc: 'Faça crescer o seu negócio junto ao nosso com sinergias reais.',
    ctaTitle: 'Pronto para ser nosso Parceiro?',
    ctaBtn: 'Solicitar Parceria',
    ctaWhatsapp: 'Perguntar por WhatsApp',
  },

  ganaDineroPage: {
    seoTitle: 'Ganhe Dinheiro Online | Estratégias Digitais | Punto Hispano',
    seoDesc: 'Aprenda a monetizar as suas competências e criar rendimentos digitais a partir da Suíça.',
    heroTitle: 'Ganhe Dinheiro Online',
    heroDesc: 'Estratégias comprovadas para gerar rendimentos no mundo digital.',
    backToEmprende: 'Voltar a Emprende',
    strategiesTitle: 'Estratégias para Gerar Rendimentos',
    strategiesDesc: 'Descubra as melhores formas de ganhar dinheiro online.',
    tipsLabel: 'Dicas chave:',
    ctaTitle: 'Precisa de ajuda para começar?',
    ctaDesc: 'Aconselhamos-lhe para lançar o seu negócio digital.',
    ctaBtn: 'Consulta Gratuita',
    ctaWhatsapp: 'WhatsApp',
  },

  transmiteIdeasPage: {
    seoTitle: 'Submeta a Sua Ideia de Projeto | Punto Hispano',
    seoDesc: 'Conte-nos a sua ideia de projeto digital e ajudamo-lo a torná-la realidade.',
    heroTitle: 'Conte-nos a Sua Ideia',
    heroDesc: 'Descreva o seu projeto e a nossa equipa aconselhará sobre como realizá-lo.',
    backToEmprende: 'Voltar a Emprende',
    formTitle: 'Descreva o seu projeto',
    labelName: 'Nome completo',
    placeholderName: 'O seu nome',
    labelEmail: 'Endereço de email',
    labelPhone: 'Telefone (opcional)',
    placeholderPhone: '+41 XX XXX XX XX',
    labelProjectType: 'Tipo de projeto',
    labelDescription: 'Descreva a sua ideia',
    placeholderDescription: 'Conte-nos os detalhes do seu projeto...',
    labelBudget: 'Orçamento estimado',
    labelUrgency: 'Urgência',
    labelFeatures: 'Funcionalidades necessárias',
    submitBtn: 'Enviar Ideia',
    sending: 'A enviar...',
    successTitle: 'Ideia Recebida!',
    successDesc: 'Recebemos a sua proposta. Entraremos em contacto para avaliar o seu projeto.',
    sendAnother: 'Enviar outra ideia',
    guaranteeTitle: 'O nosso compromisso',
    guarantee1: 'Resposta em 24-48h',
    guarantee2: 'Avaliação gratuita',
    guarantee3: 'Sem compromisso',
    guarantee4: 'Orçamento detalhado',
  },

  authPage: {
    loginTitle: 'Iniciar Sessão',
    loginDesc: 'Aceda à sua conta Punto Hispano.',
    signupTitle: 'Criar Conta',
    signupDesc: 'Registe-se para aceder a todos os nossos serviços.',
    email: 'Endereço de email',
    password: 'Palavra-passe',
    confirmPassword: 'Confirmar palavra-passe',
    name: 'Nome completo',
    loginBtn: 'Iniciar Sessão',
    signupBtn: 'Criar Conta',
    forgotPassword: 'Esqueceu a palavra-passe?',
    noAccount: 'Não tem conta?',
    hasAccount: 'Já tem conta?',
    signupLink: 'Registar',
    loginLink: 'Iniciar sessão',
    orContinueWith: 'Ou continuar com',
    google: 'Google',
    resetTitle: 'Repor Palavra-passe',
    resetDesc: 'Insira o seu email e enviaremos um link para repor a sua palavra-passe.',
    resetBtn: 'Enviar link',
    resetSuccess: 'Enviámos um link para o seu email.',
    backToLogin: 'Voltar ao login',
  },

  avisoLegalPage: {
    seoTitle: 'Aviso Legal | Punto Hispano',
    seoDesc: 'Informações legais completas sobre a Punto Hispano e os seus serviços.',
    title: 'Aviso Legal',
    subtitle: 'Informações legais completas sobre a Punto Hispano e os nossos serviços',
    whatIs: 'O que é este aviso legal?',
    whatIsP1: 'Este aviso legal regula a utilização do site web www.puntohispano.ch, propriedade da Punto Hispano GmbH, empresa registada na Suíça.',
    whatIsP2: 'Ao navegar no nosso site web, aceita todas as condições aqui estabelecidas. Recomendamos que leia atentamente estas informações.',
    whoWeAre: 'Quem somos?',
    idData: 'Dados de identificação',
    company: 'Empresa',
    companySubtitle: 'Gestão & Assessoria na Suíça',
    officialAddress: 'Morada oficial',
    contactTitle: 'Como contactar-nos?',
    digitalComm: 'Comunicação digital',
    directComm: 'Comunicação direta',
    mainEmail: 'E-mail principal:',
    website: 'Site web:',
    phone: 'Telefone:',
    officeHours: 'Horário de atendimento:',
    weekdayHours: 'Segunda a sexta: 9:00 - 18:00',
    saturdayHours: 'Sábados: 10:00 - 14:00',
    termsTitle: 'Condições de utilização do site web',
    term1Title: '1. Aceitação das condições',
    term1Desc: 'Ao aceder e utilizar este site web, aceita automaticamente ficar vinculado a estas condições de utilização.',
    term2Title: '2. Utilização permitida',
    term2Desc: 'Este site web destina-se exclusivamente a:',
    term2Items: ['Obter informações sobre os nossos serviços', 'Solicitar consultas e orçamentos', 'Contactar a nossa equipa profissional', 'Aceder a recursos e documentação'],
    term3Title: '3. Utilização proibida',
    term3Warning: 'É estritamente proibido:',
    term3Items: ['Utilizar o site para atividades ilegais', 'Tentar aceder a áreas restritas', 'Copiar ou reproduzir conteúdos sem autorização', 'Enviar informações falsas ou enganosas', 'Interferir com o funcionamento do site'],
    ipTitle: 'Propriedade intelectual e industrial',
    ipProtected: 'O que está protegido?',
    ipDesc: 'Todos os elementos deste site web estão protegidos pelas leis suíças de propriedade intelectual e industrial.',
    ipVisual: 'Elementos visuais',
    ipVisualItems: ['Design e layout', 'Logótipos e marcas', 'Imagens e fotografias', 'Ícones e gráficos'],
    ipTechnical: 'Elementos técnicos',
    ipTechnicalItems: ['Código de programação', 'Base de dados', 'Arquitetura web', 'Funcionalidades'],
    ipWarning: 'A reprodução, distribuição ou qualquer forma de exploração dos conteúdos sem autorização é expressamente proibida.',
    responsibilityTitle: 'Responsabilidades e limitações',
    ourCommitment: 'O nosso compromisso',
    ourCommitmentDesc: 'A Punto Hispano compromete-se a manter este site web operacional. No entanto, não podemos garantir:',
    ourCommitmentItems: ['Disponibilidade contínua 24/7', 'Ausência total de erros técnicos', 'Compatibilidade com todos os navegadores', 'Proteção absoluta contra ciberataques'],
    userResponsibility: 'Responsabilidade do utilizador',
    userResponsibilityDesc: 'Como utilizador do site web, é responsável por:',
    userResponsibilityItems: ['Fornecer informações verdadeiras e atualizadas', 'Manter a confidencialidade das suas credenciais', 'Utilizar o site de forma responsável e legal', 'Respeitar os direitos de propriedade intelectual'],
    lawTitle: 'Legislação aplicável e jurisdição',
    applicableLaw: 'Lei aplicável',
    applicableLawDesc: 'Este aviso legal rege-se pelo direito suíço, Cantão de Zurique.',
    jurisdiction: 'Jurisdição competente',
    jurisdictionDesc: 'As partes submetem-se à jurisdição dos tribunais de Zurique, Suíça.',
    faqTitle: 'Perguntas jurídicas frequentes',
    faqMoreInfo: 'Precisa de informações legais? Contacte os nossos especialistas para uma consulta personalizada',
    relatedPolicies: 'Políticas relacionadas',
    dataProtection: 'Proteção de Dados',
    dataProtectionDesc: 'Saiba como protegemos as suas informações pessoais',
    cookiePolicyLink: 'Política de Cookies',
    cookiePolicyDesc: 'Informações sobre a utilização de cookies',
    privacyPolicyLink: 'Política de Privacidade',
    privacyPolicyDesc: 'Termos gerais de privacidade',
    legalQuestions: 'Questões legais?',
    legalQuestionsDesc: 'Não hesite em contactar-nos para qualquer questão.',
    lastUpdated: 'Última atualização:',
    lastUpdatedDate: '24 de junho de 2025',
  },
  politicaPrivacidadPage: {
    seoTitle: 'Política de Privacidade | Proteção de Dados Pessoais | Punto Hispano',
    seoDesc: 'Política de privacidade completa da Punto Hispano. Saiba como recolhemos, utilizamos e protegemos as suas informações pessoais.',
    titlePart1: 'Política de',
    titlePart2: 'Privacidade',
    subtitle: 'A sua privacidade é fundamental. Saiba como protegemos as suas informações com os mais altos padrões de segurança.',
    gdprBadge: 'Conforme ao RGPD',
    encryptionBadge: 'Encriptação AES-256',
    isoBadge: 'ISO 27001',
    introTitle: 'Porque é importante a sua privacidade?',
    introP1Pre: 'Na',
    introP1Brand: 'Punto Hispano',
    introP1Post: ', valorizamos e respeitamos a sua privacidade como direito fundamental. Esta Política explica de forma transparente como recolhemos, utilizamos, partilhamos e protegemos as informações pessoais que nos fornece.',
    introHighlight: 'Ao utilizar os nossos serviços, aceita as práticas descritas nesta Política de Privacidade.',
    introBadge1: 'Transparência Total',
    introBadge2: 'Máxima Segurança',
    introBadge3: 'Controlo Total',
    whatTitle: 'Que informações recolhemos?',
    whatIntro: 'Recolhemos diferentes tipos de informações pessoais para lhe oferecer os nossos serviços profissionais da melhor forma.',
    section1Title: '1. Informações que nos fornece',
    idCardTitle: 'Dados de identificação',
    idCard1: 'Nome e apelidos completos',
    idCard2: 'Documento de identidade (BI, NIE, passaporte)',
    idCard3: 'Data de nascimento e nacionalidade',
    contactCardTitle: 'Informações de contacto',
    contactCard1: 'Endereço de email',
    contactCard2: 'Números de telefone móvel e fixo',
    contactCard3: 'Morada postal completa',
    profCardTitle: 'Dados profissionais',
    profCard1: 'Empresa onde trabalha e cargo',
    profCard2: 'Setor de atividade profissional',
    profCard3: 'Informação laboral relevante',
    finCardTitle: 'Informação financeira',
    finCard1: 'Dados bancários (para processamento de pagamentos)',
    finCard2: 'Informação fiscal necessária',
    finCard3: 'Documentação financeira para serviços específicos',
    section2Title: '2. Informações recolhidas automaticamente',
    autoIntroLabel: 'O que recolhemos?',
    autoIntroDesc: 'Quando visita o nosso site, recolhemos automaticamente certa informação técnica.',
    autoUseLabel: 'Dados de utilização:',
    autoUseDesc: 'páginas visitadas, tempo de permanência, links utilizados',
    autoDeviceLabel: 'Informação do dispositivo:',
    autoDeviceDesc: 'tipo de dispositivo, sistema operativo, navegador',
    autoLocLabel: 'Informação de localização:',
    autoLocDesc: 'país e região (com base no seu IP)',
    autoCookiesLabel: 'Cookies:',
    autoCookiesDesc: 'para mais informação, consulte a nossa Política de Cookies',
    useTitle: 'Como utilizamos as suas informações?',
    useIntro: 'Utilizamos os seus dados pessoais exclusivamente para os seguintes fins legítimos:',
    useServicesTitle: 'Serviços principais',
    useService1: 'Fornecer e manter os nossos serviços',
    useService2: 'Processar transações e pagamentos',
    useService3: 'Gerir a sua conta e perfil',
    useService4: 'Cumprir obrigações contratuais',
    useCommTitle: 'Comunicação',
    useComm1: 'Responder a pedidos e consultas',
    useComm2: 'Enviar atualizações de serviços',
    useComm3: 'Fornecer suporte técnico',
    useComm4: 'Comunicar informação importante',
    useImproveTitle: 'Melhoria e análise',
    useImprove1: 'Personalizar a sua experiência',
    useImprove2: 'Analisar tendências e utilização',
    useImprove3: 'Melhorar os nossos serviços',
    useImprove4: 'Desenvolver novas funcionalidades',
    useSecTitle: 'Segurança e legal',
    useSec1: 'Detetar atividades fraudulentas',
    useSec2: 'Cumprir obrigações legais',
    useSec3: 'Proteger direitos e segurança',
    useSec4: 'Resolver disputas legais',
    legalTitle: 'Base legal para o tratamento',
    legalIntro: 'Tratamos os seus dados pessoais com base nas seguintes bases legais reconhecidas:',
    legal1Title: 'Execução de um contrato',
    legal1Desc: 'Quando o tratamento é necessário para cumprir as nossas obrigações contratuais consigo.',
    legal2Title: 'Consentimento',
    legal2Desc: 'Quando deu o seu consentimento explícito para o tratamento com um fim específico.',
    legal3Title: 'Interesses legítimos',
    legal3Desc: 'Quando o tratamento é necessário para os nossos interesses legítimos, sem prevalecer sobre os seus direitos fundamentais.',
    legal4Title: 'Obrigação legal',
    legal4Desc: 'Quando o tratamento é necessário para cumprir uma obrigação legal aplicável.',
    shareTitle: 'Com quem partilhamos as suas informações?',
    shareImportant: 'IMPORTANTE: Não vendemos os seus dados pessoais a terceiros',
    shareIntro: 'Podemos partilhar os seus dados apenas com as seguintes categorias de destinatários:',
    share1Title: 'Prestadores de serviços',
    share1Desc: 'Empresas que prestam serviços em nosso nome (pagamentos, análises, alojamento, suporte) sob rigorosos acordos de confidencialidade.',
    share2Title: 'Parceiros comerciais',
    share2Desc: 'Terceiros com quem colaboramos para serviços específicos ou promoções, sempre com o seu consentimento prévio.',
    share3Title: 'Autoridades competentes',
    share3Desc: 'Quando necessário para cumprir uma obrigação legal, decisão judicial ou requerimento administrativo válido.',
    share4Title: 'Transações empresariais',
    share4Desc: 'No contexto de uma transação empresarial (fusão, aquisição, venda), protegendo sempre os seus direitos.',
    intlTitle: 'Transferências internacionais de dados',
    intlIntro: 'Os seus dados podem ser transferidos para países com leis de proteção diferentes.',
    intlGuaranteeLabel: 'Garantias de proteção:',
    intlGuaranteeDesc: 'Quando transferimos dados fora do EEE ou Suíça, garantimos proteções adequadas, como cláusulas contratuais-tipo aprovadas pela Comissão Europeia.',
    secTitle: 'Como protegemos as suas informações?',
    secIntro: 'Implementamos medidas de segurança técnicas, administrativas e físicas para proteger os seus dados.',
    secTechTitle: 'Medidas técnicas',
    secTech1: 'Encriptação AES-256 para armazenamento',
    secTech2: 'Comunicações SSL/TLS seguras',
    secTech3: 'Sistemas de deteção de intrusões',
    secTech4: 'Cópias de segurança encriptadas',
    secAdminTitle: 'Medidas administrativas',
    secAdmin1: 'Acesso restrito a pessoal autorizado',
    secAdmin2: 'Formação regular em proteção de dados',
    secAdmin3: 'Políticas internas de segurança',
    secAdmin4: 'Auditorias de segurança periódicas',
    secLimitsLabel: 'Limitações:',
    secLimitsDesc: 'Apesar das melhores medidas, nenhum sistema é totalmente impenetrável. Não podemos garantir segurança absoluta.',
    retentionTitle: 'Quanto tempo guardamos os seus dados?',
    retentionIntro: 'Conservamos os seus dados apenas pelo tempo necessário, salvo obrigações legais mais longas.',
    ret1Title: 'Documentos contratuais',
    ret1Desc: 'Vigência do contrato + 6 anos',
    ret2Title: 'Documentos fiscais',
    ret2Desc: '10 anos (lei suíça)',
    ret3Title: 'Comunicações',
    ret3Desc: '3 anos desde a última interação',
    ret4Title: 'Dados de navegação',
    ret4Desc: 'Máximo 2 anos',
    rightsTitle: 'Quais são os seus direitos?',
    rightsIntro: 'Dependendo do seu local de residência, tem direitos importantes sobre os seus dados pessoais:',
    rightAccessTitle: 'Direito de acesso',
    rightAccessDesc: 'Pode solicitar informação sobre os dados que temos sobre si.',
    rightRectifyTitle: 'Direito de retificação',
    rightRectifyDesc: 'Pode pedir a correção de dados incorretos ou incompletos.',
    rightDeleteTitle: 'Direito à eliminação',
    rightDeleteDesc: 'Pode pedir a eliminação dos seus dados pessoais.',
    rightPortTitle: 'Direito à portabilidade',
    rightPortDesc: 'Pode receber os seus dados num formato estruturado e transferi-los.',
    rightOpposeTitle: 'Direito de oposição',
    rightOpposeDesc: 'Pode opor-se ao tratamento em determinadas circunstâncias.',
    rightWithdrawTitle: 'Retirada de consentimento',
    rightWithdrawDesc: 'Pode retirar o seu consentimento a qualquer momento.',
    rightsHowLabel: 'Como exercer os seus direitos?',
    rightsHowDesc: 'Para exercer estes direitos, contacte-nos através da informação na secção "Contacto".',
    faqTitle: 'Perguntas frequentes sobre privacidade',
    faqSubtitle: 'Respostas claras às suas dúvidas mais comuns.',
    faq1Q: 'Que informação pessoal recolhe a Punto Hispano?',
    faq1A: 'Recolhemos dados de identificação, contacto, profissionais e financeiros necessários para os nossos serviços, apenas com o seu consentimento.',
    faq2Q: 'Como protege a Punto Hispano os meus dados?',
    faq2A: 'Implementamos medidas técnicas e administrativas avançadas, incluindo encriptação AES-256, comunicações SSL/TLS e acesso restrito.',
    faq3Q: 'Posso pedir a eliminação dos meus dados?',
    faq3A: 'Sim, tem o direito de pedir a eliminação dos seus dados quando já não forem necessários, respeitando obrigações legais.',
    faq4Q: 'A Punto Hispano partilha os meus dados com terceiros?',
    faq4A: 'Não vendemos os seus dados. Apenas os partilhamos com fornecedores de confiança, por obrigações legais ou com o seu consentimento explícito.',
    changesTitle: 'Alterações a esta Política de Privacidade',
    changesP1: 'Podemos atualizar esta Política periodicamente para refletir mudanças nas nossas práticas ou na regulamentação.',
    changesNotifyLabel: 'Iremos notificá-lo:',
    changesNotifyDesc: 'Qualquer mudança material será comunicada publicando a nova Política e atualizando a data de "última atualização".',
    contactTitle: 'Tem perguntas sobre privacidade?',
    contactIntro: 'Para qualquer pergunta ou preocupação sobre esta Política ou o tratamento dos seus dados, contacte-nos:',
    contactCompanyLabel: 'Empresa:',
    contactCompanyValue: 'Punto Hispano',
    contactAddressLabel: 'Morada:',
    contactEmailLabel: 'Email:',
    contactPhoneLabel: 'Telefone:',
    lastUpdated: 'Última atualização:',
    lastUpdatedDate: '24 de junho de 2025',
    lastUpdateNote: 'Esta política pode ser modificada para refletir mudanças nas nossas práticas ou regulamentação aplicável',
  },
  politicaCookiesPage: {
    seoTitle: 'Política de Cookies | Punto Hispano',
    seoDesc: 'Informações sobre os cookies que utilizamos e como gerir as suas preferências.',
    title: 'Política de Cookies',
    subtitle: 'Transparência total sobre como utilizamos cookies no nosso site web',
    whatAreCookies: 'O que são cookies e porque os utilizamos?',
    whatAreCookiesP1: 'Os cookies são pequenos ficheiros de texto guardados no seu dispositivo quando visita o nosso site web. São completamente seguros e ajudam-nos a oferecer uma melhor experiência.',
    whatAreCookiesP2: 'Na Punto Hispano utilizamos cookies de forma responsável e transparente, em conformidade com a regulamentação europeia.',
    cookieTypes: 'Que tipos de cookies utilizamos?',
    essentialTitle: 'Cookies essenciais ou necessários',
    essentialWhat: 'O que fazem?',
    essentialWhatDesc: 'São imprescindíveis para o correto funcionamento do nosso site web.',
    essentialWhy: 'Porque precisamos deles?',
    essentialWhyDesc: 'Permitem a navegação, o acesso a áreas seguras e as funcionalidades básicas.',
    essentialNote: 'Estes cookies não requerem o seu consentimento pois são tecnicamente necessários.',
    preferencesTitle: 'Cookies de preferências',
    preferencesWhatDesc: 'Memorizam as suas preferências para personalizar a sua experiência.',
    preferencesExamples: 'Idioma selecionado, definições de acessibilidade, preferências de navegação.',
    preferencesNote: 'Melhoram a sua experiência mas não são imprescindíveis.',
    analyticsTitle: 'Cookies estatísticos ou analíticos',
    analyticsWhatDesc: 'Ajudam-nos a compreender como utiliza o nosso site web de forma anónima.',
    analyticsWhyDesc: 'Melhoramos constantemente os nossos serviços com base em dados reais.',
    analyticsNote: 'Os dados são processados de forma anónima e agregada.',
    marketingTitle: 'Cookies de marketing',
    marketingWhatDesc: 'Permitem-nos mostrar-lhe conteúdo e ofertas mais relevantes.',
    marketingHowDesc: 'Rastreiam o seu comportamento de navegação para personalizar a experiência.',
    marketingNote: 'Pode sempre desativar estes cookies sem afetar o funcionamento do site.',
    specificCookies: 'Cookies específicos que utilizamos',
    tableName: 'Nome',
    tableProvider: 'Fornecedor',
    tablePurpose: 'Finalidade',
    tableDuration: 'Duração',
    tableType: 'Tipo',
    controlTitle: 'Como controlar os cookies?',
    controlDesc: 'Tem o controlo total. Pode aceitá-los, rejeitá-los ou configurá-los conforme as suas preferências.',
    onOurSite: 'No nosso site web',
    onOurSiteDesc: 'Quando visita pela primeira vez, aparece um banner onde pode:',
    onOurSiteItems: ['Aceitar todos os cookies', 'Rejeitar os não essenciais', 'Configurar as suas preferências em detalhe'],
    inBrowser: 'No seu navegador',
    inBrowserDesc: 'Também pode gerir os cookies diretamente no seu navegador:',
    inBrowserItems: ['Bloquear todos os cookies', 'Eliminar cookies existentes', 'Configurar exceções por site web'],
    browserSettings: 'Definições do navegador',
    thirdPartyCookies: 'Cookies de terceiros',
    thirdPartyWarning: 'Alguns serviços externos (como o Google Analytics) podem instalar os seus próprios cookies.',
    thirdPartyDesc: 'Asseguramos que:',
    thirdPartyItems: ['Trabalhamos apenas com fornecedores que respeitam a privacidade', 'Os dados são processados de forma anónima', 'Cumprem a regulamentação europeia', 'Pode desativá-los se desejar'],
    changesTitle: 'Alterações à nossa Política de Cookies',
    changesDesc: 'Podemos atualizar esta política ocasionalmente.',
    changesNotice: 'Qualquer alteração importante será comunicada claramente no nosso site web.',
    questionsTitle: 'Dúvidas sobre cookies?',
    questionsDesc: 'Não hesite em contactar-nos:',
    lastUpdated: 'Última atualização:',
    lastUpdatedDate: '24 de junho de 2025',
  },
  politicaGdprPage: {
    seoTitle: 'Política RGPD | Proteção de Dados Pessoais | Punto Hispano',
    seoDesc: 'Política de proteção de dados pessoais segundo o RGPD. Conheça os seus direitos e como tratamos as suas informações.',
    title: 'Proteção de Dados Pessoais',
    subtitle: 'A sua privacidade é a nossa prioridade — Conheça os seus direitos segundo o RGPD',
    whyImportant: 'Porque é importante a sua privacidade?',
    whyImportantP1: 'Na Punto Hispano tratamos as suas informações pessoais com o máximo respeito e transparência. Cumprimos o RGPD e a Lei Federal Suíça de Proteção de Dados.',
    whyImportantP2: 'Esta política explica-lhe de forma simples que dados recolhemos, como os utilizamos e quais são os seus direitos.',
    whoResponsible: 'Quem é responsável pelos seus dados?',
    whoResponsibleDesc: 'Punto Hispano Holding é a empresa responsável pelo tratamento dos seus dados pessoais.',
    ourAddress: 'A nossa morada:',
    phoneLabel: 'Telefone:',
    emailGeneralLabel: 'Email geral:',
    whatData: 'Que informações recolhemos?',
    whatDataIntro: 'Apenas recolhemos as informações necessárias para lhe oferecer os nossos serviços profissionais. A quantidade e o tipo dependem do serviço solicitado.',
    data1Title: '1. Dados básicos de identificação',
    data1What: 'O que inclui:',
    data1WhatDesc: 'Nome completo, documento de identidade, data de nascimento, nacionalidade.',
    data1Why: 'Porque os precisamos:',
    data1WhyDesc: 'Essenciais para prestar serviços legais e administrativos na Suíça.',
    data2Title: '2. Informações de contacto',
    data2WhatDesc: 'Morada postal, telefones, email, contacto de emergência.',
    data2WhyDesc: 'Para comunicar consigo e enviar documentos importantes.',
    data3Title: '3. Dados profissionais e financeiros',
    data3WhatDesc: 'Situação laboral, empresa, rendimentos, documentos fiscais.',
    data3WhyDesc: 'Para tratar de questões administrativas, fiscais e de seguros.',
    data4Title: '4. Dados especiais (apenas com a sua permissão)',
    data4Important: 'Importante:',
    data4ImportantDesc: 'Apenas tratamos dados sensíveis com o seu consentimento expresso.',
    data4WhatDesc: 'Estado civil, dados de saúde (para seguros médicos), informações bancárias.',
    data4Control: 'O seu controlo:',
    data4ControlDesc: 'Pode retirar este consentimento a qualquer momento.',
    rightsTitle: 'Quais são os seus direitos?',
    rightsIntro: 'Como titular de dados pessoais, tem direitos importantes que pode exercer a qualquer momento:',
    right1Title: 'Direito a saber',
    right1Desc: 'Pode solicitar informação sobre que dados temos, como os usamos e com quem os partilhamos.',
    right2Title: 'Direito a corrigir',
    right2Desc: 'Se houver dados incorretos ou incompletos, pode solicitar a correção imediata.',
    right3Title: 'Direito ao esquecimento',
    right3Desc: 'Pode pedir que eliminemos os seus dados quando já não forem necessários (respeitando obrigações legais).',
    right4Title: 'Direito à portabilidade',
    right4Desc: 'Pode receber os seus dados em formato digital para os transferir para outro fornecedor.',
    howExercise: 'Como exercer os seus direitos?',
    howExerciseIntro: 'É muito fácil. Pode contactar-nos por qualquer destes meios:',
    byEmail: 'Por email',
    byEmailWrite: 'Escreva para:',
    byEmailNote: 'Inclua cópia do seu documento de identidade',
    byPhone: 'Por telefone',
    byPhoneCall: 'Ligue:',
    byPhoneNote: 'Horário de escritório',
    inPerson: 'Presencialmente',
    inPersonVisit: 'Visite os nossos escritórios',
    inPersonNote: 'Solicite marcação prévia',
    responseTime: 'Tempo de resposta:',
    responseTimeDesc: 'Respondemos em no máximo 30 dias. Para casos complexos podemos precisar de até 60 dias, mas avisaremos.',
    howProtect: 'Como protegemos as suas informações?',
    securityMeasures: 'Medidas de segurança',
    securityIntro: 'Implementamos as melhores medidas técnicas para proteger os seus dados:',
    security1: 'Cifragem AES-256 para armazenamento',
    security2: 'Comunicações seguras SSL/TLS',
    security3: 'Acesso restrito apenas a pessoal autorizado',
    security4: 'Cópias de segurança encriptadas',
    security5: 'Formação regular da equipa em proteção de dados',
    retention: 'Quanto tempo guardamos os seus dados?',
    retentionIntro: 'Apenas conservamos as suas informações pelo tempo necessário:',
    retention1Label: 'Documentos fiscais:',
    retention1Desc: '10 anos (lei suíça)',
    retention2Label: 'Marketing:',
    retention2Desc: 'Até retirar o consentimento',
    retention3Label: 'Comunicações:',
    retention3Desc: '3 anos desde a última interação',
    retention4Label: 'Dados web:',
    retention4Desc: 'Máximo 2 anos',
    international: 'Transferências internacionais',
    internationalDesc: 'Se necessitarmos de transferir dados para fora da Europa, fazemo-lo apenas para países com proteção adequada (como Espanha) ou fornecedores certificados nos EUA.',
    questionsTitle: 'Tem dúvidas ou queixas?',
    questionsIntro: 'Se tem perguntas sobre esta política ou sobre como tratamos os seus dados, contacte o nosso Encarregado da Proteção de Dados:',
    emailLabel: 'Email:',
    complaintLabel: 'Direito de reclamação:',
    complaintDesc: 'Se considerar que não cumprimos a normativa, pode apresentar queixa à Autoridade Federal Suíça de Proteção de Dados (CFPD) ou à autoridade do seu país de residência.',
    lastUpdated: 'Última atualização:',
    lastUpdatedDate: '24 de junho de 2025',
    updateNote: 'Notificaremos qualquer alteração importante a esta política',
  },
  heroHome: {
    titleLine1: 'Pare de sobreviver.',
    titleLine2: 'Comece a viver na Suíça.',
    subtitle: 'Sabemos como é sentir-se perdido com a burocracia. Recupere a sua tranquilidade: nós cuidamos de tudo.',
    cta: 'Descubra as nossas soluções',
    statFamilies: 'Famílias tranquilas',
    statFamiliesDesc: 'Já resolveram os seus trâmites',
    statYears: 'Anos de experiência',
    statYearsDesc: 'Problemas reais como o seu',
    statAvailable: 'Sempre disponíveis',
    statAvailableDesc: 'Quando precisar de nós, estamos aqui',
    statSolutions: 'Soluções',
    statSolutionsDesc: 'Para cada problema que enfrenta',
  },
  footerLinks: {
    servicios: 'Serviços', gestoria: 'Gestão', lifestyle: 'Lifestyle', empresa: 'Empresa', legal: 'Legal',
    gestoriaAdmin: 'Gestão & Administração', asesoriaLegal: 'Assessoria Jurídica', formacionIdiomas: 'Formação em Idiomas', segurosPensiones: 'Seguros & Previdência',
    desempleoRav: 'Desemprego (ORP)', administracion: 'Administração', cvDoc: 'CV & Documentos', acompanamientos: 'Acompanhamentos', traducciones: 'Traduções', paquetes: 'Pacotes Especiais',
    vehiculos: 'Aluguer de Veículos', viviendas: 'Aluguer de Habitações', packRelocation: 'Pack Relocation', solucionesDigitales: 'Soluções Digitais',
    sobreNosotros: 'Sobre Nós', blog: 'Blog', contacto: 'Contacto', zonasServicio: 'Zonas de Serviço',
    privacidad: 'Política de Privacidade', avisoLegal: 'Aviso Legal', cookies: 'Política de Cookies', gdpr: 'RGPD',
    invalidEmail: 'E-mail inválido', errorRetry: 'Erro. Tente novamente.', followUs: 'Siga-nos em',
  },
  navbar: {
    tagline: 'A sua gestão & assessoria na', contactUs: 'Contacte-nos', closeMenu: 'Fechar menu', openMenu: 'Abrir menu',
    myProfile: 'O meu Perfil', logout: 'Sair', login: 'Login',
  },
  cart: {
    title: 'O seu Carrinho', emptyCart: 'O seu carrinho está vazio', service: 'serviço', services: 'serviços', selected: 'selecionados', clearCart: 'Esvaziar carrinho',
    limitedOffer: 'Oferta Limitada!', addMoreServices: 'Adicione mais serviços e obtenha descontos exclusivos',
    numberOfPeople: 'Número de pessoas:', couponPlaceholder: 'Código de cupão', apply: 'Aplicar',
    subtotal: 'Subtotal:', persons: 'pessoas:', discount: 'Desconto:', total: 'Total:', continue: 'Continuar', backToCart: '← Voltar ao carrinho',
    couponInvalid: 'Cupão inválido ou expirado', couponExpired: 'Este cupão expirou', couponMaxUses: 'Este cupão atingiu o limite de utilização',
    couponMinPurchase: 'Compra mínima de {amount} CHF necessária', couponApplied: 'Cupão aplicado!', couponDiscount: 'Desconto de {discount}',
    couponRemoved: 'Cupão removido', couponRemovedDesc: 'O desconto foi removido', couponError: 'Erro na validação do cupão',
    serviceRemoved: 'Serviço removido', serviceRemovedDesc: '"{title}" foi removido do carrinho',
    paymentMigration: 'Pagamentos em migração', paymentMigrationDesc: 'Estamos a migrar este checkout. Contacte-nos para finalizar o seu pedido.',
    paymentError: 'Não foi possível continuar', paymentErrorDesc: 'Tente novamente dentro de momentos',
  },
  contactForm: {
    fullName: 'Nome completo', email: 'E-mail', phone: 'Telefone', serviceArea: 'Área de serviço', selectService: 'Selecionar um serviço',
    message: 'Mensagem', messagePlaceholder: 'Descreva a sua consulta ou projeto...', characters: 'caracteres',
    send: 'Enviar mensagem', sending: 'A enviar...', formErrors: 'Erros no formulário:', formErrorsDesc: 'Por favor, corrija os erros indicados.',
    tooManyAttempts: 'Demasiadas tentativas. Tente novamente em {seconds} segundos.', submitError: 'Erro ao enviar. Tente novamente.',
    successTitle: 'Mensagem enviada', successDesc: 'Obrigado por nos contactar. Responderemos em breve.',
    errorTitle: 'Erro', errorDesc: 'Ocorreu um erro ao enviar a mensagem.',
    gestoriaOption: 'Gestão & Administração', legalOption: 'Assessoria Jurídica', segurosOption: 'Seguros & Previdência',
    idiomasOption: 'Cursos de Idiomas', digitalOption: 'Serviços Digitais', webOption: 'Web Design', crmOption: 'CRM',
    iaOption: 'Inteligência Artificial', automationOption: 'Automatização', devOption: 'Desenvolvimento Personalizado', generalOption: 'Consulta Geral',
    namePlaceholder: 'O seu nome completo',
  },
  categoryHero: { requestInfo: 'Solicitar informações', meetTeam: 'Conheça a nossa equipa' },
  gestoriaCategoryPage: {
    specializedAgency: 'Gestão Especializada', professionalService: 'Serviço profissional em espanhol para hispanófonos na Suíça.',
    freeConsultation: 'Consulta Gratuita', callNow: 'Ligar Agora',
    clientsServed: 'Clientes atendidos', fastResponse: 'Resposta rápida', inSpanish: 'Em espanhol', averageRating: 'Classificação média',
    servicesOf: 'Serviços de', finalPrices: 'Todos os preços são finais. Sem custos ocultos.', popular: 'Popular', add: 'Adicionar', consult: 'Consultar',
    freeOrConsult: 'Gratuito ou consultar', freeOrConsultDesc: 'Contacte-nos para mais informações.',
    addedToCart: 'Adicionado ao carrinho',
    howItWorks: 'Como funciona?', step1: 'Contacto', step1Desc: 'Conte-nos a sua situação por WhatsApp ou telefone',
    step2: 'Documentação', step2Desc: 'Reunimos toda a documentação necessária', step3: 'Gestão', step3Desc: 'Realizamos todos os trâmites por si',
    step4: 'Resultado', step4Desc: 'Entregamos tudo concluído e explicado',
    needHelp: 'Precisa de ajuda com', firstFree: 'Primeira consulta gratuita. Sem compromisso.', whatsapp: 'WhatsApp',
  },
  categoryFaq: { defaultTitle: 'Perguntas frequentes' },
  categoryBlog: { defaultTitle: 'Artigos relacionados', viewAll: 'Ver todos os artigos', readMore: 'Ler mais' },
  categoryContact: {
    defaultTitle: 'Contacte os nossos especialistas', defaultDesc: 'Solicite informações ou um orçamento personalizado',
    preferDirect: 'Prefere falar diretamente?', teamAvailable: 'A nossa equipa está disponível para responder a todas as suas perguntas por WhatsApp ou agendar uma chamada.',
    formSent: 'Formulário enviado!', formSentDesc: 'Obrigado por nos contactar. Um membro da equipa entrará em contacto consigo brevemente.',
    sendAnother: 'Enviar outra mensagem', name: 'Nome', namePlaceholder: 'O seu nome completo', email: 'E-mail',
    phoneOptional: 'Telefone (opcional)', serviceArea: 'Área de serviço', selectService: 'Selecionar um serviço',
    message: 'Mensagem', messagePlaceholder: 'Descreva a sua consulta em detalhe', sending: 'A enviar...', send: 'Enviar mensagem',
    successTitle: 'Formulário enviado com sucesso', successDesc: 'Entraremos em contacto consigo brevemente',
  },
  writeReview: {
    title: 'Escrever uma avaliação', whereToWrite: 'Onde gostaria de escrever a sua avaliação?',
    googleReview: 'Avaliação Google', googleDesc: 'Pública, aparece no Google Maps',
    websiteReview: 'Avaliação no nosso site', websiteDesc: 'Aparece no nosso site após verificação',
    recommendGoogle: 'Recomendamos também escrever no Google para máxima visibilidade',
    redirectGoogle: 'Redirecionamento para o Google', redirectGoogleDesc: 'Será levado ao Google Maps.',
    goToGoogle: 'Ir para o Google Maps', goBack: 'Voltar',
    nameLabel: 'Nome *', emailLabel: 'E-mail *', ratingLabel: 'Classificação *', starsOf: 'de 5 estrelas',
    serviceUsed: 'Serviço utilizado', selectServicePlaceholder: 'Selecionar o serviço',
    reviewTitle: 'Título da avaliação', reviewTitlePlaceholder: 'Resumo da sua experiência',
    yourReview: 'A sua avaliação *', yourReviewPlaceholder: 'Conte-nos sobre a sua experiência com os nossos serviços...',
    submitReview: 'Enviar avaliação', submitting: 'A enviar...',
    reviewNote: '* A sua avaliação será verificada antes da publicação.',
    requiredFields: 'Campos obrigatórios', requiredFieldsDesc: 'Por favor, preencha todos os campos obrigatórios.',
    reviewSent: 'Avaliação enviada!', reviewSentDesc: 'A sua avaliação será verificada. Obrigado pelo seu feedback!',
    reviewError: 'Não foi possível enviar a avaliação. Tente novamente.',
    gestoria: 'Gestão', legal: 'Assessoria Jurídica', seguros: 'Seguros', idiomas: 'Formação em Idiomas',
    web: 'Desenvolvimento Web', crm: 'CRM & Automatização', general: 'Consulta Geral',
  },
  blogNewsletter: {
    welcomeTitle: 'Bem-vindo à nossa comunidade!', welcomeDesc: 'Receberá os nossos melhores conteúdos e dicas exclusivas',
    title: 'Newsletter Exclusiva para Hispanófonos', subtitle: 'Receba semanalmente guias práticos e conselhos jurídicos',
    exclusive: 'Conteúdo Exclusivo', exclusiveDesc: 'Guias não disponíveis no blog',
    legalUpdates: 'Atualizações Legais', legalUpdatesDesc: 'Alterações fiscais e legais na Suíça',
    weeklyTips: 'Dicas Semanais', weeklyTipsDesc: 'Dicas práticas todas as semanas',
    namePlaceholder: 'O seu nome (opcional)', subscribing: 'A subscrever...', subscribe: 'Subscrever Grátis',
    noSpam: 'Sem spam. Pode cancelar a qualquer momento.',
    invalidEmail: 'E-mail inválido', invalidEmailDesc: 'Por favor, introduza um e-mail válido',
    successTitle: 'Subscrição realizada!', successDesc: 'Enviámos-lhe um e-mail de confirmação',
    errorTitle: 'Erro', errorDesc: 'Problema com a subscrição. Tente novamente.',
  },
  exitIntent: {
    defaultTitle: 'Espere! Temos algo para si', defaultDesc: 'Antes de sair, deixe o seu e-mail e receba uma consulta gratuita de 10 minutos',
    defaultOffer: 'Consulta gratuita', submit: 'Quero a minha consulta grátis',
    sending: 'A enviar...', thanks: 'Obrigado! Contactaremos em breve',
    error: 'Erro ao enviar. Tente novamente', dismiss: 'Não obrigado, continuar a navegar',
  },
  contactInline: {
    nameFull: 'Nome completo', namePlaceholder: 'O seu nome', email: 'E-mail',
    phoneOptional: 'Telefone (opcional)', serviceInterest: 'Serviço de interesse',
    selectService: 'Selecionar um serviço', gestoria: 'Gestão & Administração', legal: 'Assessoria Jurídica',
    idiomas: 'Formação em Idiomas', seguros: 'Seguros & Previdência', digital: 'Soluções Digitais',
    coches: 'Aluguer de Carros', viviendas: 'Aluguer de Habitações', relocation: 'Pack Relocation',
    orientacion: 'Não tenho a certeza — preciso de orientação',
    whatWorries: 'O que o preocupa?', tellUs: 'Conte-nos brevemente a sua situação...',
    sending: 'A enviar...', sendFree: 'Enviar a minha Consulta Grátis',
    dataPrivacy: '🔒 Os seus dados são confidenciais. Não partilhamos as suas informações.',
    sentTitle: 'Mensagem Enviada!', sentDesc: 'Respondemos num máximo de 2 horas.',
    sendAnother: 'Enviar outra mensagem', successTitle: 'Mensagem enviada!', successDesc: 'Respondemos em menos de 2 horas.',
    errorTitle: 'Erro no envio', errorDesc: 'Ocorreu um problema. Tente novamente.',
  },
  homeFeatured: {
    kicker: 'Serviços em destaque', deliveredThisYear: 'serviços prestados este ano',
    title: 'Serviços profissionais na Suíça para hispanófonos',
    subtitle: 'Gestão, assessoria jurídica e transformação digital, tudo no seu idioma',
    desc: 'Otimize impostos, regularize a sua situação e faça crescer o seu negócio',
    viewAll: 'Ver Todos os Serviços',
    gestoria: 'Gestão Fiscal', gestoriaDesc: 'Assessoria fiscal personalizada para particulares e empresas.',
    gestoriaBtn: 'Ver serviços de gestão',
    legal: 'Assessoria Jurídica', legalDesc: 'Serviço jurídico especializado para a comunidade hispanófona.',
    legalBtn: 'Ver serviços jurídicos',
    digital: 'Soluções Digitais', digitalDesc: 'Transformação digital para impulsionar o seu negócio.',
    digitalBtn: 'Ver soluções digitais',
    feat1: 'Declarações de impostos', feat2: 'Planeamento fiscal', feat3: 'Contabilidade', feat4: 'Otimização fiscal',
    feat5: 'Imigração & residência', feat6: 'Contratos de trabalho', feat7: 'Direito da família', feat8: 'Assessoria imobiliária',
    feat9: 'Web design profissional', feat10: 'Sistemas CRM personalizados', feat11: 'Automatização de processos', feat12: 'Marketing digital eficaz',
  },
  homeStats: {
    title: 'Resultados que inspiram confiança', updated: 'Atualizado 2025',
    clients: 'Clientes Satisfeitos', clientsDesc: 'Confiaram em nós',
    procedures: 'Trâmites Concluídos', proceduresDesc: 'Resolução bem-sucedida',
    companies: 'Empresas Criadas', companiesDesc: 'Em toda a Suíça',
    experience: 'Anos de Experiência', experienceDesc: 'Serviço continuado',
  },
  homeTestimonials: {
    title: 'O Que Dizem os Nossos Clientes', subtitle: 'Avaliações reais de clientes satisfeitos',
    basedOn: 'Baseado em 50+ avaliações Google', verified: 'Verificado', googleReview: 'Avaliação Google',
    viewAll: 'Ver todas as avaliações', leaveReview: 'Deixe-nos uma avaliação',
    usedServices: 'Utilizou os nossos serviços? A sua opinião é muito importante para nós.',
  },
  serviciosSection: {
    title: 'Serviços', titleAccent: 'chave para a sua vida na Suíça',
    subtitle: 'Tudo num só lugar, sem barreiras linguísticas.',
    gestoria: 'Gestão & Administração', gestoriaDesc: 'Impostos e contabilidade sem complicações.',
    legal: 'Assessoria Jurídica', legalDesc: 'Imigração, trabalho e família com advogados bilingues.',
    idiomas: 'Cursos de Alemão', idiomasDesc: 'Progressos desde a primeira semana.',
    seguros: 'Seguros & 3º Pilar', segurosDesc: 'Comparação independente. Poupanças reais.',
    digital: 'Soluções Digitais', digitalDesc: 'Web + CRM + IA para crescer na Suíça.',
    coches: 'Aluguer de Carros', cochesDesc: 'Entrega flexível, todo o risco, em espanhol.',
    viviendas: 'Aluguer de Habitações', viviendasDesc: 'Organizamos visitas e contrato, você escolhe.',
    relocation: 'Pack Relocation', relocationDesc: 'Chega e nós resolvemos tudo em 30 dias.',
    bestSeller: 'Mais vendido 🔥', forHispanics: 'Para hispanófonos', save25: 'Poupe até 25%', allInclusive: 'Tudo incluído ✅',
    learnMore: 'Saber mais', customSolution: 'Precisa de uma solução personalizada?',
    customDesc: 'Contacte os nossos especialistas para uma consulta gratuita.',
    enterBtn: 'Entrar', creating: 'A criar conta...', createBtn: 'Criar conta',
    trustClients: 'Clientes satisfeitos', trustResponse: 'Tempo de resposta', trustResponseValue: '< 2 horas',
    trustLanguages: 'Idiomas', trustLanguagesValue: 'ES, DE, EN',
  },
  resetPassword: {
    seoTitle: 'Nova Password - Punto Hispano', seoDesc: 'Defina a sua nova password',
    successSeoTitle: 'Password Atualizada', successSeoDesc: 'A sua password foi atualizada',
    invalidLink: 'Link inválido ou expirado', invalidLinkDesc: 'Solicite um novo link',
    passwordMin: 'A password deve ter pelo menos 8 caracteres',
    mismatch: 'As passwords não coincidem', mismatchDesc: 'Verifique que ambas as passwords são iguais',
    tooShort: 'Password muito curta', tooShortDesc: 'Mínimo 8 caracteres',
    successTitle: 'Password atualizada!', successDesc: 'A sua password foi alterada com sucesso',
    successRedirect: 'Password alterada com sucesso. Será redirecionado automaticamente...',
    goToClient: 'Ir para a área cliente', newPassword: 'Nova Password', enterNew: 'Introduza a sua nova password',
    newPasswordLabel: 'Nova password', minChars: 'Mínimo 8 caracteres',
    confirmPassword: 'Confirmar password', repeatPassword: 'Repetir a password',
    updating: 'A atualizar...', changePassword: 'Alterar password',
    errorTitle: 'Erro ao alterar', errorDesc: 'Problema ao alterar a sua password',
  },

  contactFormPage: {
    seoTitle: 'Formulário de Contacto | Punto Hispano',
    seoDesc: 'Contacte-nos para consultas sobre os nossos serviços para a comunidade hispanófona na Suíça.',
    title: 'Formulário de Contacto',
    subtitle: 'Preencha o formulário abaixo para nos enviar a sua consulta. A nossa equipa entrará em contacto o mais brevemente possível.',
    successTitle: 'Mensagem Enviada!',
    successDesc: 'Obrigado por nos contactar. Recebemos a sua mensagem e responderemos num prazo de 24-48 horas úteis.',
    sendAnother: 'Enviar outra mensagem',
    labelName: 'Nome completo',
    placeholderName: 'Introduza o seu nome',
    labelEmail: 'Endereço de e-mail',
    placeholderEmail: 'nome@exemplo.com',
    labelPhone: 'Telefone (opcional)',
    placeholderPhone: 'O seu número de telefone',
    labelServiceArea: 'Área de serviço',
    selectArea: 'Selecione uma área',
    optGestoria: 'Gestão e Administração',
    optLegal: 'Assessoria Legal',
    optIdiomas: 'Formação em Idiomas',
    optSeguros: 'Seguros e Pensões',
    optDigital: 'Soluções Digitais',
    optCoches: 'Aluguer de Carros',
    optViviendas: 'Aluguer de Habitação',
    labelMessage: 'Mensagem',
    placeholderMessage: 'Como podemos ajudá-lo?',
    submitBtn: 'Enviar Mensagem',
    sending: 'A enviar...',
    toastSuccess: 'Formulário enviado',
    toastSuccessDesc: 'Recebemos a sua mensagem e entraremos em contacto em breve.',
    toastError: 'Erro ao enviar',
    toastErrorDesc: 'Ocorreu um problema ao enviar a sua mensagem. Por favor, tente novamente.',
    privacyNote: 'Ao enviar este formulário, aceita a nossa',
    privacyLink: 'política de privacidade',
    privacyNote2: 'e o tratamento dos seus dados para responder à sua consulta.',
    fastResponse: 'Resposta rápida',
    fastResponseDesc: '24-48 horas úteis',
    noCommitment: 'Sem compromisso',
    noCommitmentDesc: 'Orçamentos personalizados',
    spanishSupport: 'Atendimento em espanhol',
    spanishSupportDesc: 'Equipa 100% hispanófona',
    validationName: 'O nome deve ter pelo menos 2 caracteres',
    validationEmail: 'Introduza um endereço de e-mail válido',
    validationService: 'Selecione uma área de serviço',
    validationMessage: 'A mensagem deve ter pelo menos 10 caracteres',
    interestedIn: 'Estou interessado em informações sobre os serviços de',
  },

  serviceTemplates: {
    freeWhatsapp: 'Consulta Gratuita pelo WhatsApp',
    askWhatsapp: 'Pedir Informações pelo WhatsApp',
    whatsappDirect: 'WhatsApp Direto',
    notSure: 'Não tem certeza do que precisa? Escreva-nos — orientamos gratuitamente.',
    backTo: 'Voltar a',
    popular: 'Popular',
    bestSeller: 'Mais Vendido',
    allIncluded: 'Tudo Incluído',
    free: 'Grátis',
    servicesAvailable: 'serviços disponíveis',
    serviceAvailable: 'serviço disponível',
    packagesAvailable: 'pacotes disponíveis',
    packageAvailable: 'pacote disponível',
    whichForYou: 'Qual é o certo para você?',
    freeConsultation: 'Consulta Gratuita pelo WhatsApp',
    gestoriaBreadcrumb: 'Gestão Administrativa',
    legalBreadcrumb: 'Consultoria Jurídica',
    legalFreeConsult: 'Consulta Gratuita pelo WhatsApp',
    legalNotSure: 'Não tem certeza do que precisa? Orientamos gratuitamente.',
    segurosBreadcrumb: 'Seguros & Previdência',
    segurosInsured: '+20.000 pessoas seguradas em 5 anos',
    relocationBreadcrumb: 'Pack Relocation',
    relocationNeedHelp: 'Olá, preciso de orientação sobre o Pack Relocation.',
  },
  cookieBanner: {
    title: 'Cookies',
    description: 'Usamos cookies para melhorar a sua experiência.',
    moreInfo: 'Mais informações',
    adjust: 'Personalizar',
    reject: 'Rejeitar',
    accept: 'Aceitar',
    preferences: 'Preferências',
    necessary: 'Necessários',
    functional: 'Funcionais',
    analytics: 'Analíticos',
    marketing: 'Marketing',
    required: 'obrigatório',
    onlyNecessary: 'Apenas necessários',
    save: 'Guardar',
  },
  sectionNav: {
    home: 'Início',
    services: 'Serviços',
    about: 'Sobre nós',
    process: 'Processo',
    testimonials: 'Depoimentos',
    faq: 'FAQ',
    contact: 'Contacto',
  },
  helpWidget: {
    help: 'Ajuda?',
    assistant: 'Assistente',
    minimize: 'Minimizar widget de ajuda',
    howCanWeHelp: 'COMO PODEMOS AJUDÁ-LO?',
    online: 'Estamos online',
    closeMenu: 'Fechar menu de ajuda',
    aiChat: 'CHAT COM IA',
    aiChatDesc: 'Resposta instantânea 24/7',
  },
};

export default pt;
